// ----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
// ----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as moment from 'moment';

export class UseAccessTokenForApi {
  public accessToken: string | undefined;
  /**
   * Prepares the fetch request to add the x-access-token header if needed
   *
   * @param options The options to be configured
   * @returns The configured request
   */
  protected transformOptions (options: RequestInit): Promise<RequestInit> {
    if (this.accessToken) {
      (options.headers as Record<string, string>)['x-access-token'] = this.accessToken;
    }
    options.credentials = 'same-origin';
    return Promise.resolve(options);
  }
}

export interface ISpotClient {

    /**
     * @param body The model used for authentication
     * @return The login result
     */
    login(body: LoginModel): Promise<LoginResult>;

    /**
     * @return The login result
     */
    renewToken(): Promise<RenewTokenResult>;

    /**
     * @return The result of the logout operation
     */
    logout(): Promise<LogoutResult>;

    /**
     * @return The user info
     */
    whoAmI(): Promise<UserModel>;

    /**
     * @return The visits info
     */
    getVisits(): Promise<{ [key: string]: moment.Moment; }>;

    /**
     * @return The filters saved by the connected user
     */
    getUsersFilters(): Promise<{ [key: string]: SavedFilter[]; }>;

    /**
     * @param body The filter to save
     * @return No content
     */
    saveUserFilter(body: SaveFilterRequest): Promise<void>;

    /**
     * @return The configurations saved by the connected user
     */
    getUserTrainingPathReportConfigurations(): Promise<SavedTrainingPathReportConfiguration[]>;

    /**
     * @param body The configurations to save
     * @return No content
     */
    saveUserTrainingPathReportConfigurations(body: SavedTrainingPathReportConfiguration[]): Promise<void>;

    /**
     * @param redirectUrl The URL to redirect to after a successful login
     * @return The list of all identity providers
     */
    getIdentityProviders(redirectUrl: string): Promise<IdentityProviderModel[]>;

    /**
     * @return The unordered list of all cartographies
     */
    getAllCartographies(): Promise<SiteModel[]>;

    /**
     * @param name The name to search in the cartography database
     * @param visibleOnly (optional) Only return the cartographies that the user is allowed to see
     * @return The matching cartography-sites from the database
     */
    searchCartographySite(name: string, visibleOnly: boolean | undefined): Promise<IdAndNameModel[]>;

    /**
     * @param body The cartography identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the cartography-site names as values. Id that are not found are ignored in the result.
     */
    getCartographySiteNames(body: string[]): Promise<{ [key: string]: string; }>;

    /**
     * @param cartographyId The identifier of the cartography to retrieve
     * @return The image that represents the cartography
     */
    getCartographyImage(cartographyId: string): Promise<string>;

    /**
     * @param cartographyId The identifier of the cartography to retrieve
     * @return The clickable zones to display on the cartography
     */
    getCartographyImageZones(cartographyId: string): Promise<CartographyZone[]>;

    /**
     * @param discussionId The discussion identifier
     * @return The discussion model
     */
    getDiscussion(discussionId: string): Promise<DiscussionModel>;

    /**
     * @param discussionId The discussion identifier
     * @param body The message to be sent on the discussion
     * @return Info about the created message
     */
    postMessage(discussionId: string, body: PostMessageRequest): Promise<CreatedMessageModel>;

    /**
     * @param from The date (inclusive) after which to extract user actions
     * @param to The date (inclusive) before which to extract user actions
     * @return The matching tracking actions from the database
     */
    getMyTracking(from: moment.Moment, to: moment.Moment): Promise<TrackingActionResult[]>;

    /**
     * @param body The query parameters
     * @return The matching tracking actions from the database
     */
    getContributions(body: ContributionsQuery): Promise<ContributionCounter[]>;

    /**
     * @return The matching course from the LMS database
     */
    getAllCourses(): Promise<LmsCourseModelNode[]>;

    /**
     * @param id The id of the root to get
     * @return The matching course from the LMS database
     */
    getCourseById(id: string): Promise<LmsCourseModelNode>;

    /**
     * @param body The ids of the quiz attempts
     * @return The matching course from the LMS database
     */
    getLmsQuizAttempts(body: string[]): Promise<LmsQuizAttempt[]>;

    /**
     * @param body The query parameters
     * @return The requested mediations, ordered by date descending (oldest will be the last)
     */
    queryMediations(body: QueryRequest): Promise<QueryResponse_MediationModel_>;

    /**
     * @return The requested mediations, ordered by ascending date (oldest first)
     */
    getActionableMediations(): Promise<MediationModel[]>;

    /**
     * @param mediationId The mediation identifier
     * @return The requested mediation
     */
    getMediationById(mediationId: string): Promise<MediationModel>;

    /**
     * @param mediationId The mediation identifier to update
     * @param body The medation creation options
     * @return No content
     */
    updateMediation(mediationId: string, body: CreateOrUpdateMediationRequest): Promise<void>;

    /**
     * @param body The medation creation options
     * @return The created mediation's info
     */
    createMediation(body: CreateOrUpdateMediationRequest): Promise<EntityCreatedModel>;

    /**
     * @param mediationId The mediation identifier
     * @param body The new status that is requested
     * @return No content
     */
    setMediationStatus(mediationId: string, body: MediationStatusRequest): Promise<void>;

    /**
     * @param mediationId The mediation identifier
     * @param body The new periods of tracking to consider when calling getTracking. The periods must be sorted and must not overlap.
     * @return No content
     */
    updateTrackingPeriods(mediationId: string, body: TrackingPeriodModel[]): Promise<void>;

    /**
     * @param mediationId The mediation identifier
     * @param body The report that is to be saved
     * @return No content
     */
    saveMediationReport(mediationId: string, body: MediationReport): Promise<void>;

    /**
     * @param mediationId The mediation identifier
     * @return No content
     */
    signMediation(mediationId: string): Promise<void>;

    /**
     * @return The organization logo
     */
    getOrganizationLogo(): Promise<string>;

    /**
     * @return The application's logo
     */
    getApplicationLogo(): Promise<string>;

    /**
     * @return the registered organization information
     */
    getOrganizationInformation(): Promise<OrganisationInformation>;

    /**
     * @return The discussion model
     */
    getAllPermissions(): Promise<GroupPermission[]>;

    /**
     * @return The permissions list
     */
    getGroupPermissionsList(): Promise<string[]>;

    /**
     * @param groupId The group identifier for which to set the permissions
     * @param body The permissions to set
     * @return No content
     */
    setGroupPermissions(groupId: string, body: string[]): Promise<void>;

    /**
     * @param itemType type of item to search for (site or cartography only)
     * @param itemId identifier of item to search for
     * @return list of identifiers of groups allowed to see item
     */
    getAllowedGroupsForItem(itemType: ContextItemType, itemId: string): Promise<string[]>;

    /**
     * @return the cartographies tree (all cartographies for all sites)
     */
    getCartographiesTree(): Promise<TreeItem[]>;

    /**
     * @param groupId the identifier of the group
     * @return the list of allowed item identifiers
     */
    getAllowedItemsForGroup(groupId: string): Promise<string[]>;

    /**
     * @param groupId the identifier of the group
     * @param body the list of item identifiers that this group can see
     * @return No content
     */
    setAllowedItemsForGroup(groupId: string, body: string[]): Promise<void>;

    /**
     * @param cartographyId The identifier of the cartography for which to retrieve the activity pictos
     * @return The activities pictos
     */
    getCartographyActivityPictos(cartographyId: string): Promise<{ [key: string]: string; }>;

    /**
     * @param body The query parameters
     * @return The requested qualifications
     */
    queryQualifications(body: QueryRequest): Promise<QueryResponse_QualificationModel_>;

    /**
     * @param body The query parameters
     * @return The requested user qualifications
     */
    queryUserQualifications(body: QueryRequest): Promise<QueryResponse_UserQualificationModel_>;

    /**
     * @param qualificationId The qualification identifier
     * @return The qualification model
     */
    getQualificationById(qualificationId: string): Promise<QualificationModel>;

    /**
     * @param qualificationId The qualification to update
     * @param body The qualification update options
     * @return No content
     */
    updateQualification(qualificationId: string, body: CreateOrUpdateQualificationRequest): Promise<void>;

    /**
     * @param qualificationId The module identifier to delete
     * @return No content
     */
    deleteQualification(qualificationId: string): Promise<void>;

    /**
     * @param body The qualification creation options
     * @return The created qualification
     */
    createQualification(body: CreateOrUpdateQualificationRequest): Promise<EntityCreatedModel>;

    /**
     * @param parentType the type of the parent (subject, function, ...)
     * @param parentId the identifier of the parent object
     * @return the list of attached resources (can be empty)
     */
    getResources(parentType: ResourceParentType, parentId: string): Promise<ResourceModel[]>;

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param resourceType the type of resource to be sent
     * @param name The name of the resource to be sent
     * @param link For link type : defines target url, for youtube type: the video identifier, for image, pdf or file types : stores original file name
     * @param comment (optional) The comment associated with the resource (Optional)
     * @param body (optional)
     * @return the id of created resource
     */
    createResource(parentType: ResourceParentType, parentId: string, resourceType: ResourceType, name: string, link: string, comment: string | undefined, body: Blob | undefined): Promise<EntityCreatedModel>;

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param resourceId the identifier of the resource
     * @param body the resource info to update
     * @return No content
     */
    updateResource(parentType: ResourceParentType, parentId: string, resourceId: string, body: UpdateResourceModel): Promise<void>;

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param body the list of resource identifiers (in expected display order)
     * @return No content
     */
    reorderResource(parentType: ResourceParentType, parentId: string, body: string[]): Promise<void>;

    /**
     * @param parentType the type of the parent (subject, function, ...)
     * @param parentId the identifier of the parent object
     * @param resourceId the identifier of the resource to delete
     * @return No content
     */
    deleteResource(parentType: ResourceParentType, parentId: string, resourceId: string): Promise<void>;

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param resourceId the identifier of the resource
     * @return the resource file content
     */
    getResourceFile(parentType: ResourceParentType, parentId: string, resourceId: string): Promise<string>;

    /**
     * @param subjectId The subject identifier
     * @return The requested subject
     */
    getSubjectById(subjectId: string): Promise<SubjectModel>;

    /**
     * @param subjectId The subject identifier to update
     * @param body The subject options
     * @return No content
     */
    updateSubject(subjectId: string, body: CreateOrUpdateSubjectRequest): Promise<void>;

    /**
     * @param subjectId The subject identifier to delete
     * @return No content
     */
    deleteSubject(subjectId: string): Promise<void>;

    /**
     * @param body The subject creation options
     * @return The created subject's info
     */
    createSubject(body: CreateOrUpdateSubjectRequest): Promise<EntityCreatedModel>;

    /**
     * @param subjectId The subject identifier to duplicate
     * @param body The subject creation options
     * @return The created subject's info
     */
    duplicateSubject(subjectId: string, body: CreateOrUpdateSubjectRequest): Promise<EntityCreatedModel>;

    /**
     * @param subjectId The subject identifier
     * @return No content
     */
    followSubject(subjectId: string): Promise<void>;

    /**
     * @param subjectId The subject identifier
     * @return No content
     */
    resolveSubject(subjectId: string): Promise<void>;

    /**
     * @param subjectId The subject identifier
     * @param body The new subject rating
     * @return No content
     */
    rateSubject(subjectId: string, body: SubjectRatings): Promise<void>;

    /**
     * @param subjectId The subject identifier
     * @param body The standardization options
     * @return No content
     */
    standardizeSubject(subjectId: string, body: StandardizationRequest): Promise<void>;

    /**
     * @param body The query parameters
     * @return The requested modules, ordered by name ascending
     */
    queryTrainingModules(body: QueryRequest): Promise<QueryResponse_TrainingModuleModel_>;

    /**
     * @param body The training module identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the training module names as values. Id that are not found are ignored in the result.
     */
    getTrainingModuleNames(body: string[]): Promise<{ [key: string]: string; }>;

    /**
     * @param name The name to search in the module database
     * @return The matching modules from the database
     */
    searchTrainingModule(name: string): Promise<IdAndNameModel[]>;

    /**
     * @param trainingModuleId The training module identifier
     * @return The training module model
     */
    getTrainingModuleById(trainingModuleId: string): Promise<TrainingModuleModel>;

    /**
     * @param trainingModuleId The module identifier to update
     * @param body The training module update options
     * @return No content
     */
    updateTrainingModule(trainingModuleId: string, body: CreateOrUpdateTrainingModuleRequest): Promise<void>;

    /**
     * @param trainingModuleId The module identifier to delete
     * @return No content
     */
    deleteTrainingModule(trainingModuleId: string): Promise<void>;

    /**
     * @param body The training module creation options
     * @return The created training module
     */
    createTrainingModule(body: CreateOrUpdateTrainingModuleRequest): Promise<EntityCreatedModel>;

    /**
     * @param trainingModuleId The module identifier to update
     * @param body The training module update options
     * @return No content
     */
    setTrainingModuleEnabled(trainingModuleId: string, body: SetTrainingModuleEnabledRequest): Promise<void>;

    /**
     * @param trainingModuleId The module identifier to request
     * @return The statistics about the module usage in the training path
     */
    getTrainingModuleUsageStats(trainingModuleId: string): Promise<TrainingModuleUsageStats>;

    /**
     * @param trainingPathId The training path identifier
     * @return The training path model
     */
    getTrainingPathById(trainingPathId: string): Promise<TrainingPathModel>;

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    deleteTrainingPath(trainingPathId: string): Promise<void>;

    /**
     * @param trainingPathId The training path to update.
     * @param body The training path
     * @return No content
     */
    updateTrainingPath(trainingPathId: string, body: UpdateTrainingPathRequest): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @return The training path status
     */
    getTrainingPathStatusById(trainingPathId: string): Promise<TrainingPathStatus>;

    /**
     * @param body The training path identifiers
     * @return The mapping that contains the training path info for each training path id found
     */
    getTrainingPathInfoByIds(body: string[]): Promise<{ [key: string]: TrainingPathInfoModel; }>;

    /**
     * @param body The query parameters
     * @return The requested path, ordered by date descending (oldest will be the last)
     */
    queryTrainingPaths(body: QueryRequest): Promise<QueryResponse_TrainingPathModel_>;

    /**
     * @param body The training path creation options
     * @return The created training path
     */
    createTrainingPaths(body: CreateTrainingPathRequest): Promise<EntityCreatedModel[]>;

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    cancelTrainingPath(trainingPathId: string): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    startTrainingPath(trainingPathId: string): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    implicitStartTrainingPath(trainingPathId: string): Promise<void>;

    /**
     * @param trainingPathId The training path to start. It must belong to the user.
     * @param body The content of the signature body (=the associatedcomment)
     * @return No content
     */
    validateTrainingPath(trainingPathId: string, body: TrainingPathValidationRequest): Promise<void>;

    /**
     * @param trainingPathId The training path to start. It must belong to the user.
     * @param body The content of the signature body (=the associatedcomment)
     * @return No content
     */
    signTrainingPath(trainingPathId: string, body: SignatureRequest): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    updateTrainingPathResults(trainingPathId: string): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @param body The grade given to the module
     * @return No content
     */
    setAssignedModuleGrade(trainingPathId: string, moduleIndex: number, body: SetGradeRequest): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @return No content
     */
    startTrainingPathModuleNow(trainingPathId: string, moduleIndex: number): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @return No content
     */
    disableTrainingPathModule(trainingPathId: string, moduleIndex: number): Promise<void>;

    /**
     * @param trainingPathId The training path to start. It must belong to the user.
     * @param moduleIndex The index of the module in the training path
     * @param body The content of the signature body (=the associatedcomment)
     * @return No content
     */
    signAssignedModule(trainingPathId: string, moduleIndex: number, body: SignatureRequest): Promise<void>;

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @param resultIndex The index of the module item for which to put a result
     * @return No content
     */
    setTrainingPathUrlResult(trainingPathId: string, moduleIndex: number, resultIndex: number): Promise<void>;

    /**
     * @param trainingPathId The training path identifier to modify
     * @param moduleIndex The index of the module in the training path
     * @param resultIndex The index of the module item for which to attach a mediation
     * @param mediationId The id of the mediation to attach
     * @return No content
     */
    attachMediationToTrainingPathResult(trainingPathId: string, moduleIndex: number, resultIndex: number, mediationId: string): Promise<void>;

    /**
     * @param trainingPathId The training path identifier to modify
     * @param moduleIndex The index of the module in the training path
     * @param resultIndex The index of the module item for which to attach a mediation
     * @param mediationId The id of the mediation to detach
     * @return No content
     */
    detachMediationFromTrainingPathResult(trainingPathId: string, moduleIndex: number, resultIndex: number, mediationId: string): Promise<void>;

    /**
     * @param body The query parameters
     * @return The requested assigned modules
     */
    queryAssignedTrainingModules(body: QueryRequest): Promise<QueryResponse_AssignedTrainingModuleQueryResultModel_>;

    /**
     * @param trainingReferenceType The list of training references to query
     * @param body The query parameters
     * @return The requested modules, ordered by name ascending
     */
    queryTrainingReferences(trainingReferenceType: TrainingReferenceType, body: QueryRequest): Promise<QueryResponse_TrainingReferenceModel_>;

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param trainingReferenceCode The training reference identifier
     * @return The training reference model
     */
    getTrainingReference(trainingReferenceType: TrainingReferenceType, trainingReferenceCode: string): Promise<TrainingReferenceModel>;

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param trainingReferenceCode The training reference info
     * @return No content
     */
    deleteTrainingReference(trainingReferenceType: TrainingReferenceType, trainingReferenceCode: string): Promise<void>;

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param body The training reference info
     * @return No content
     */
    createOrUpdateTrainingReference(trainingReferenceType: TrainingReferenceType, body: TrainingReferenceModel): Promise<void>;

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param trainingReferenceCode The training reference identifier
     * @return The statistics about the reference usage in the training path and training modules
     */
    getTrainingReferenceUsageStats(trainingReferenceType: TrainingReferenceType, trainingReferenceCode: string): Promise<TrainingReferenceUsageStats>;

    /**
     * @param name The name to search in the user database
     * @return The matching users from the database
     */
    searchUser(name: string): Promise<IdAndNameModel[]>;

    /**
     * @param body The user identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the user names as values. Id that are not found are ignored in the result.
     */
    getUserNames(body: string[]): Promise<{ [key: string]: string; }>;

    /**
     * @param body The identifiers of the groups to get users from
     * @return The matching users from the database
     */
    getUserByGroups(body: string[]): Promise<IdAndNameModel[]>;

    /**
     * @param userId The user identifier
     * @return The user info
     */
    getUserById(userId: string): Promise<UserInfoModel>;

    /**
     * @param userId The id of the user to edit
     * @param body The user to edit
     * @return No content
     */
    editUser(userId: string, body: Id__): Promise<void>;

    /**
     * @param userId The id of the user to delete
     * @return No content
     */
    deleteUser(userId: string): Promise<void>;

    /**
     * @param body The users identifiers
     * @return The mapping that associates the found user identifiers with the resolved infos
     */
    getUsersByIds(body: string[]): Promise<{ [key: string]: UserInfoModel; }>;

    /**
     * @param externalId The external user identifier
     * @return The info about the users that have the given externalId
     */
    findUsersByExternalId(externalId: string): Promise<UserInfoModel[]>;

    /**
     * @param name The name to search in the user database
     * @return The matching users from the database
     */
    findUserByName(name: string): Promise<UserInfoModel[]>;

    /**
     * @param login The login to search in the user database
     * @return The matching users from the database
     */
    findUserByLogin(login: string): Promise<UserInfoModel[]>;

    /**
     * @param body The user to create
     * @return The info about the created entity
     */
    createUser(body: CreateUserModel): Promise<EntityCreatedModel>;

    /**
     * @param userId The id of the user to edit
     * @param body The info about the new password
     * @return No content
     */
    changeUserPassword(userId: string, body: ChangePasswordModel): Promise<void>;

    /**
     * @param name The name to search in the user database
     * @return The matching groups from the database
     */
    searchGroup(name: string): Promise<IdAndNameModel[]>;

    /**
     * @param body The user identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the user names as values. Id that are not found are ignored in the result.
     */
    getGroupNames(body: string[]): Promise<{ [key: string]: string; }>;

    /**
     * @param body The identifiers of the users for which to get the groups
     * @return The mapping of the users associated with the groups they belong to
     */
    getUsersGroups(body: string[]): Promise<{ [key: string]: IdAndNameModel[]; }>;
}

export class SpotClient extends UseAccessTokenForApi implements ISpotClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/backend/api/v2";
    }

    /**
     * @param body The model used for authentication
     * @return The login result
     */
    login(body: LoginModel): Promise<LoginResult> {
        let url_ = this.baseUrl + "/account/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginResult;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Invalid login or password", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginResult>(null as any);
    }

    /**
     * @return The login result
     */
    renewToken(): Promise<RenewTokenResult> {
        let url_ = this.baseUrl + "/account/renewToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenewToken(_response);
        });
    }

    protected processRenewToken(response: Response): Promise<RenewTokenResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RenewTokenResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RenewTokenResult>(null as any);
    }

    /**
     * @return The result of the logout operation
     */
    logout(): Promise<LogoutResult> {
        let url_ = this.baseUrl + "/account/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<LogoutResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LogoutResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogoutResult>(null as any);
    }

    /**
     * @return The user info
     */
    whoAmI(): Promise<UserModel> {
        let url_ = this.baseUrl + "/account/whoAmI";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processWhoAmI(_response);
        });
    }

    protected processWhoAmI(response: Response): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel>(null as any);
    }

    /**
     * @return The visits info
     */
    getVisits(): Promise<{ [key: string]: moment.Moment; }> {
        let url_ = this.baseUrl + "/account/visits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVisits(_response);
        });
    }

    protected processGetVisits(response: Response): Promise<{ [key: string]: moment.Moment; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: moment.Moment; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: moment.Moment; }>(null as any);
    }

    /**
     * @return The filters saved by the connected user
     */
    getUsersFilters(): Promise<{ [key: string]: SavedFilter[]; }> {
        let url_ = this.baseUrl + "/account/filters";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersFilters(_response);
        });
    }

    protected processGetUsersFilters(response: Response): Promise<{ [key: string]: SavedFilter[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: SavedFilter[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: SavedFilter[]; }>(null as any);
    }

    /**
     * @param body The filter to save
     * @return No content
     */
    saveUserFilter(body: SaveFilterRequest): Promise<void> {
        let url_ = this.baseUrl + "/account/filters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveUserFilter(_response);
        });
    }

    protected processSaveUserFilter(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return The configurations saved by the connected user
     */
    getUserTrainingPathReportConfigurations(): Promise<SavedTrainingPathReportConfiguration[]> {
        let url_ = this.baseUrl + "/account/configuration/trainingPathReports";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserTrainingPathReportConfigurations(_response);
        });
    }

    protected processGetUserTrainingPathReportConfigurations(response: Response): Promise<SavedTrainingPathReportConfiguration[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SavedTrainingPathReportConfiguration[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SavedTrainingPathReportConfiguration[]>(null as any);
    }

    /**
     * @param body The configurations to save
     * @return No content
     */
    saveUserTrainingPathReportConfigurations(body: SavedTrainingPathReportConfiguration[]): Promise<void> {
        let url_ = this.baseUrl + "/account/configuration/trainingPathReports";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveUserTrainingPathReportConfigurations(_response);
        });
    }

    protected processSaveUserTrainingPathReportConfigurations(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param redirectUrl The URL to redirect to after a successful login
     * @return The list of all identity providers
     */
    getIdentityProviders(redirectUrl: string): Promise<IdentityProviderModel[]> {
        let url_ = this.baseUrl + "/account/identity-providers?";
        if (redirectUrl === undefined || redirectUrl === null)
            throw new Error("The parameter 'redirectUrl' must be defined and cannot be null.");
        else
            url_ += "redirectUrl=" + encodeURIComponent("" + redirectUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIdentityProviders(_response);
        });
    }

    protected processGetIdentityProviders(response: Response): Promise<IdentityProviderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdentityProviderModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdentityProviderModel[]>(null as any);
    }

    /**
     * @return The unordered list of all cartographies
     */
    getAllCartographies(): Promise<SiteModel[]> {
        let url_ = this.baseUrl + "/cartography";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCartographies(_response);
        });
    }

    protected processGetAllCartographies(response: Response): Promise<SiteModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SiteModel[];
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SiteModel[]>(null as any);
    }

    /**
     * @param name The name to search in the cartography database
     * @param visibleOnly (optional) Only return the cartographies that the user is allowed to see
     * @return The matching cartography-sites from the database
     */
    searchCartographySite(name: string, visibleOnly: boolean | undefined): Promise<IdAndNameModel[]> {
        let url_ = this.baseUrl + "/cartography/searchCartographySite?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (visibleOnly === null)
            throw new Error("The parameter 'visibleOnly' cannot be null.");
        else if (visibleOnly !== undefined)
            url_ += "visibleOnly=" + encodeURIComponent("" + visibleOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchCartographySite(_response);
        });
    }

    protected processSearchCartographySite(response: Response): Promise<IdAndNameModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdAndNameModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdAndNameModel[]>(null as any);
    }

    /**
     * @param body The cartography identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the cartography-site names as values. Id that are not found are ignored in the result.
     */
    getCartographySiteNames(body: string[]): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/cartography/getCartographySiteNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCartographySiteNames(_response);
        });
    }

    protected processGetCartographySiteNames(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param cartographyId The identifier of the cartography to retrieve
     * @return The image that represents the cartography
     */
    getCartographyImage(cartographyId: string): Promise<string> {
        let url_ = this.baseUrl + "/cartography/{cartographyId}/image";
        if (cartographyId === undefined || cartographyId === null)
            throw new Error("The parameter 'cartographyId' must be defined.");
        url_ = url_.replace("{cartographyId}", encodeURIComponent("" + cartographyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCartographyImage(_response);
        });
    }

    protected processGetCartographyImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param cartographyId The identifier of the cartography to retrieve
     * @return The clickable zones to display on the cartography
     */
    getCartographyImageZones(cartographyId: string): Promise<CartographyZone[]> {
        let url_ = this.baseUrl + "/cartography/{cartographyId}/zones";
        if (cartographyId === undefined || cartographyId === null)
            throw new Error("The parameter 'cartographyId' must be defined.");
        url_ = url_.replace("{cartographyId}", encodeURIComponent("" + cartographyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCartographyImageZones(_response);
        });
    }

    protected processGetCartographyImageZones(response: Response): Promise<CartographyZone[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CartographyZone[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CartographyZone[]>(null as any);
    }

    /**
     * @param discussionId The discussion identifier
     * @return The discussion model
     */
    getDiscussion(discussionId: string): Promise<DiscussionModel> {
        let url_ = this.baseUrl + "/discussion/{discussionId}";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiscussion(_response);
        });
    }

    protected processGetDiscussion(response: Response): Promise<DiscussionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DiscussionModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DiscussionModel>(null as any);
    }

    /**
     * @param discussionId The discussion identifier
     * @param body The message to be sent on the discussion
     * @return Info about the created message
     */
    postMessage(discussionId: string, body: PostMessageRequest): Promise<CreatedMessageModel> {
        let url_ = this.baseUrl + "/discussion/{discussionId}";
        if (discussionId === undefined || discussionId === null)
            throw new Error("The parameter 'discussionId' must be defined.");
        url_ = url_.replace("{discussionId}", encodeURIComponent("" + discussionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostMessage(_response);
        });
    }

    protected processPostMessage(response: Response): Promise<CreatedMessageModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreatedMessageModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreatedMessageModel>(null as any);
    }

    /**
     * @param from The date (inclusive) after which to extract user actions
     * @param to The date (inclusive) before which to extract user actions
     * @return The matching tracking actions from the database
     */
    getMyTracking(from: moment.Moment, to: moment.Moment): Promise<TrackingActionResult[]> {
        let url_ = this.baseUrl + "/history/mine?";
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined and cannot be null.");
        else
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === undefined || to === null)
            throw new Error("The parameter 'to' must be defined and cannot be null.");
        else
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMyTracking(_response);
        });
    }

    protected processGetMyTracking(response: Response): Promise<TrackingActionResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrackingActionResult[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrackingActionResult[]>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The matching tracking actions from the database
     */
    getContributions(body: ContributionsQuery): Promise<ContributionCounter[]> {
        let url_ = this.baseUrl + "/history/contributions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContributions(_response);
        });
    }

    protected processGetContributions(response: Response): Promise<ContributionCounter[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContributionCounter[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContributionCounter[]>(null as any);
    }

    /**
     * @return The matching course from the LMS database
     */
    getAllCourses(): Promise<LmsCourseModelNode[]> {
        let url_ = this.baseUrl + "/lms/courses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllCourses(_response);
        });
    }

    protected processGetAllCourses(response: Response): Promise<LmsCourseModelNode[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LmsCourseModelNode[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LmsCourseModelNode[]>(null as any);
    }

    /**
     * @param id The id of the root to get
     * @return The matching course from the LMS database
     */
    getCourseById(id: string): Promise<LmsCourseModelNode> {
        let url_ = this.baseUrl + "/lms/courses/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCourseById(_response);
        });
    }

    protected processGetCourseById(response: Response): Promise<LmsCourseModelNode> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LmsCourseModelNode;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LmsCourseModelNode>(null as any);
    }

    /**
     * @param body The ids of the quiz attempts
     * @return The matching course from the LMS database
     */
    getLmsQuizAttempts(body: string[]): Promise<LmsQuizAttempt[]> {
        let url_ = this.baseUrl + "/lms/quiz-attempts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLmsQuizAttempts(_response);
        });
    }

    protected processGetLmsQuizAttempts(response: Response): Promise<LmsQuizAttempt[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LmsQuizAttempt[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LmsQuizAttempt[]>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The requested mediations, ordered by date descending (oldest will be the last)
     */
    queryMediations(body: QueryRequest): Promise<QueryResponse_MediationModel_> {
        let url_ = this.baseUrl + "/mediation/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryMediations(_response);
        });
    }

    protected processQueryMediations(response: Response): Promise<QueryResponse_MediationModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_MediationModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_MediationModel_>(null as any);
    }

    /**
     * @return The requested mediations, ordered by ascending date (oldest first)
     */
    getActionableMediations(): Promise<MediationModel[]> {
        let url_ = this.baseUrl + "/mediation/actionable";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetActionableMediations(_response);
        });
    }

    protected processGetActionableMediations(response: Response): Promise<MediationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MediationModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediationModel[]>(null as any);
    }

    /**
     * @param mediationId The mediation identifier
     * @return The requested mediation
     */
    getMediationById(mediationId: string): Promise<MediationModel> {
        let url_ = this.baseUrl + "/mediation/{mediationId}";
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMediationById(_response);
        });
    }

    protected processGetMediationById(response: Response): Promise<MediationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MediationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MediationModel>(null as any);
    }

    /**
     * @param mediationId The mediation identifier to update
     * @param body The medation creation options
     * @return No content
     */
    updateMediation(mediationId: string, body: CreateOrUpdateMediationRequest): Promise<void> {
        let url_ = this.baseUrl + "/mediation/{mediationId}";
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateMediation(_response);
        });
    }

    protected processUpdateMediation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The medation creation options
     * @return The created mediation's info
     */
    createMediation(body: CreateOrUpdateMediationRequest): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/mediation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateMediation(_response);
        });
    }

    protected processCreateMediation(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param mediationId The mediation identifier
     * @param body The new status that is requested
     * @return No content
     */
    setMediationStatus(mediationId: string, body: MediationStatusRequest): Promise<void> {
        let url_ = this.baseUrl + "/mediation/{mediationId}/status";
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetMediationStatus(_response);
        });
    }

    protected processSetMediationStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param mediationId The mediation identifier
     * @param body The new periods of tracking to consider when calling getTracking. The periods must be sorted and must not overlap.
     * @return No content
     */
    updateTrackingPeriods(mediationId: string, body: TrackingPeriodModel[]): Promise<void> {
        let url_ = this.baseUrl + "/mediation/{mediationId}/tracking";
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTrackingPeriods(_response);
        });
    }

    protected processUpdateTrackingPeriods(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param mediationId The mediation identifier
     * @param body The report that is to be saved
     * @return No content
     */
    saveMediationReport(mediationId: string, body: MediationReport): Promise<void> {
        let url_ = this.baseUrl + "/mediation/{mediationId}/report";
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveMediationReport(_response);
        });
    }

    protected processSaveMediationReport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param mediationId The mediation identifier
     * @return No content
     */
    signMediation(mediationId: string): Promise<void> {
        let url_ = this.baseUrl + "/mediation/{mediationId}/sign";
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignMediation(_response);
        });
    }

    protected processSignMediation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return The organization logo
     */
    getOrganizationLogo(): Promise<string> {
        let url_ = this.baseUrl + "/organization/logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationLogo(_response);
        });
    }

    protected processGetOrganizationLogo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return The application's logo
     */
    getApplicationLogo(): Promise<string> {
        let url_ = this.baseUrl + "/organization/applogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetApplicationLogo(_response);
        });
    }

    protected processGetApplicationLogo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 304) {
            return response.text().then((_responseText) => {
            return throwException("Not modified", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return the registered organization information
     */
    getOrganizationInformation(): Promise<OrganisationInformation> {
        let url_ = this.baseUrl + "/organization/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrganizationInformation(_response);
        });
    }

    protected processGetOrganizationInformation(response: Response): Promise<OrganisationInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrganisationInformation;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganisationInformation>(null as any);
    }

    /**
     * @return The discussion model
     */
    getAllPermissions(): Promise<GroupPermission[]> {
        let url_ = this.baseUrl + "/permission";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllPermissions(_response);
        });
    }

    protected processGetAllPermissions(response: Response): Promise<GroupPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GroupPermission[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupPermission[]>(null as any);
    }

    /**
     * @return The permissions list
     */
    getGroupPermissionsList(): Promise<string[]> {
        let url_ = this.baseUrl + "/permission/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupPermissionsList(_response);
        });
    }

    protected processGetGroupPermissionsList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param groupId The group identifier for which to set the permissions
     * @param body The permissions to set
     * @return No content
     */
    setGroupPermissions(groupId: string, body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/permission/group/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetGroupPermissions(_response);
        });
    }

    protected processSetGroupPermissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param itemType type of item to search for (site or cartography only)
     * @param itemId identifier of item to search for
     * @return list of identifiers of groups allowed to see item
     */
    getAllowedGroupsForItem(itemType: ContextItemType, itemId: string): Promise<string[]> {
        let url_ = this.baseUrl + "/permission/allowedGroupsForItem/{itemType}/{itemId}";
        if (itemType === undefined || itemType === null)
            throw new Error("The parameter 'itemType' must be defined.");
        url_ = url_.replace("{itemType}", encodeURIComponent("" + itemType));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedGroupsForItem(_response);
        });
    }

    protected processGetAllowedGroupsForItem(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @return the cartographies tree (all cartographies for all sites)
     */
    getCartographiesTree(): Promise<TreeItem[]> {
        let url_ = this.baseUrl + "/permission/cartographiesTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCartographiesTree(_response);
        });
    }

    protected processGetCartographiesTree(response: Response): Promise<TreeItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TreeItem[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TreeItem[]>(null as any);
    }

    /**
     * @param groupId the identifier of the group
     * @return the list of allowed item identifiers
     */
    getAllowedItemsForGroup(groupId: string): Promise<string[]> {
        let url_ = this.baseUrl + "/permission/allowedItemsForGroup/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllowedItemsForGroup(_response);
        });
    }

    protected processGetAllowedItemsForGroup(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param groupId the identifier of the group
     * @param body the list of item identifiers that this group can see
     * @return No content
     */
    setAllowedItemsForGroup(groupId: string, body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/permission/allowedItemsForGroup/{groupId}";
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAllowedItemsForGroup(_response);
        });
    }

    protected processSetAllowedItemsForGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param cartographyId The identifier of the cartography for which to retrieve the activity pictos
     * @return The activities pictos
     */
    getCartographyActivityPictos(cartographyId: string): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/pictos/{cartographyId}";
        if (cartographyId === undefined || cartographyId === null)
            throw new Error("The parameter 'cartographyId' must be defined.");
        url_ = url_.replace("{cartographyId}", encodeURIComponent("" + cartographyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCartographyActivityPictos(_response);
        });
    }

    protected processGetCartographyActivityPictos(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The requested qualifications
     */
    queryQualifications(body: QueryRequest): Promise<QueryResponse_QualificationModel_> {
        let url_ = this.baseUrl + "/qualifications/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryQualifications(_response);
        });
    }

    protected processQueryQualifications(response: Response): Promise<QueryResponse_QualificationModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_QualificationModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_QualificationModel_>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The requested user qualifications
     */
    queryUserQualifications(body: QueryRequest): Promise<QueryResponse_UserQualificationModel_> {
        let url_ = this.baseUrl + "/qualifications/queryUserQualifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryUserQualifications(_response);
        });
    }

    protected processQueryUserQualifications(response: Response): Promise<QueryResponse_UserQualificationModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_UserQualificationModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_UserQualificationModel_>(null as any);
    }

    /**
     * @param qualificationId The qualification identifier
     * @return The qualification model
     */
    getQualificationById(qualificationId: string): Promise<QualificationModel> {
        let url_ = this.baseUrl + "/qualifications/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQualificationById(_response);
        });
    }

    protected processGetQualificationById(response: Response): Promise<QualificationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QualificationModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationModel>(null as any);
    }

    /**
     * @param qualificationId The qualification to update
     * @param body The qualification update options
     * @return No content
     */
    updateQualification(qualificationId: string, body: CreateOrUpdateQualificationRequest): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateQualification(_response);
        });
    }

    protected processUpdateQualification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param qualificationId The module identifier to delete
     * @return No content
     */
    deleteQualification(qualificationId: string): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/{qualificationId}";
        if (qualificationId === undefined || qualificationId === null)
            throw new Error("The parameter 'qualificationId' must be defined.");
        url_ = url_.replace("{qualificationId}", encodeURIComponent("" + qualificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteQualification(_response);
        });
    }

    protected processDeleteQualification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The qualification creation options
     * @return The created qualification
     */
    createQualification(body: CreateOrUpdateQualificationRequest): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/qualifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateQualification(_response);
        });
    }

    protected processCreateQualification(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param parentType the type of the parent (subject, function, ...)
     * @param parentId the identifier of the parent object
     * @return the list of attached resources (can be empty)
     */
    getResources(parentType: ResourceParentType, parentId: string): Promise<ResourceModel[]> {
        let url_ = this.baseUrl + "/resource/{parentType}/{parentId}";
        if (parentType === undefined || parentType === null)
            throw new Error("The parameter 'parentType' must be defined.");
        url_ = url_.replace("{parentType}", encodeURIComponent("" + parentType));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResources(_response);
        });
    }

    protected processGetResources(response: Response): Promise<ResourceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceModel[]>(null as any);
    }

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param resourceType the type of resource to be sent
     * @param name The name of the resource to be sent
     * @param link For link type : defines target url, for youtube type: the video identifier, for image, pdf or file types : stores original file name
     * @param comment (optional) The comment associated with the resource (Optional)
     * @param body (optional)
     * @return the id of created resource
     */
    createResource(parentType: ResourceParentType, parentId: string, resourceType: ResourceType, name: string, link: string, comment: string | undefined, body: Blob | undefined): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/resource/{parentType}/{parentId}";
        if (parentType === undefined || parentType === null)
            throw new Error("The parameter 'parentType' must be defined.");
        url_ = url_.replace("{parentType}", encodeURIComponent("" + parentType));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "resourceType": resourceType !== undefined && resourceType !== null ? "" + resourceType : "",
                "name": name !== undefined && name !== null ? "" + name : "",
                "link": link !== undefined && link !== null ? "" + link : "",
                "comment": comment !== undefined && comment !== null ? "" + comment : "",
                "Content-Type": "application/octet-stream",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateResource(_response);
        });
    }

    protected processCreateResource(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param resourceId the identifier of the resource
     * @param body the resource info to update
     * @return No content
     */
    updateResource(parentType: ResourceParentType, parentId: string, resourceId: string, body: UpdateResourceModel): Promise<void> {
        let url_ = this.baseUrl + "/resource/{parentType}/{parentId}/{resourceId}/update";
        if (parentType === undefined || parentType === null)
            throw new Error("The parameter 'parentType' must be defined.");
        url_ = url_.replace("{parentType}", encodeURIComponent("" + parentType));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResource(_response);
        });
    }

    protected processUpdateResource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param body the list of resource identifiers (in expected display order)
     * @return No content
     */
    reorderResource(parentType: ResourceParentType, parentId: string, body: string[]): Promise<void> {
        let url_ = this.baseUrl + "/resource/{parentType}/{parentId}/reorder";
        if (parentType === undefined || parentType === null)
            throw new Error("The parameter 'parentType' must be defined.");
        url_ = url_.replace("{parentType}", encodeURIComponent("" + parentType));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReorderResource(_response);
        });
    }

    protected processReorderResource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param parentType the type of the parent (subject, function, ...)
     * @param parentId the identifier of the parent object
     * @param resourceId the identifier of the resource to delete
     * @return No content
     */
    deleteResource(parentType: ResourceParentType, parentId: string, resourceId: string): Promise<void> {
        let url_ = this.baseUrl + "/resource/{parentType}/{parentId}/{resourceId}";
        if (parentType === undefined || parentType === null)
            throw new Error("The parameter 'parentType' must be defined.");
        url_ = url_.replace("{parentType}", encodeURIComponent("" + parentType));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteResource(_response);
        });
    }

    protected processDeleteResource(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param parentType the type of the parent (subject, function, message, ...)
     * @param parentId the identifier of the parent object
     * @param resourceId the identifier of the resource
     * @return the resource file content
     */
    getResourceFile(parentType: ResourceParentType, parentId: string, resourceId: string): Promise<string> {
        let url_ = this.baseUrl + "/resource/{parentType}/{parentId}/{resourceId}/file";
        if (parentType === undefined || parentType === null)
            throw new Error("The parameter 'parentType' must be defined.");
        url_ = url_.replace("{parentType}", encodeURIComponent("" + parentType));
        if (parentId === undefined || parentId === null)
            throw new Error("The parameter 'parentId' must be defined.");
        url_ = url_.replace("{parentId}", encodeURIComponent("" + parentId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResourceFile(_response);
        });
    }

    protected processGetResourceFile(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param subjectId The subject identifier
     * @return The requested subject
     */
    getSubjectById(subjectId: string): Promise<SubjectModel> {
        let url_ = this.baseUrl + "/subject/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubjectById(_response);
        });
    }

    protected processGetSubjectById(response: Response): Promise<SubjectModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubjectModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubjectModel>(null as any);
    }

    /**
     * @param subjectId The subject identifier to update
     * @param body The subject options
     * @return No content
     */
    updateSubject(subjectId: string, body: CreateOrUpdateSubjectRequest): Promise<void> {
        let url_ = this.baseUrl + "/subject/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSubject(_response);
        });
    }

    protected processUpdateSubject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param subjectId The subject identifier to delete
     * @return No content
     */
    deleteSubject(subjectId: string): Promise<void> {
        let url_ = this.baseUrl + "/subject/{subjectId}";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteSubject(_response);
        });
    }

    protected processDeleteSubject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The subject creation options
     * @return The created subject's info
     */
    createSubject(body: CreateOrUpdateSubjectRequest): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/subject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSubject(_response);
        });
    }

    protected processCreateSubject(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param subjectId The subject identifier to duplicate
     * @param body The subject creation options
     * @return The created subject's info
     */
    duplicateSubject(subjectId: string, body: CreateOrUpdateSubjectRequest): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/subject/{subjectId}/duplicate";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDuplicateSubject(_response);
        });
    }

    protected processDuplicateSubject(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param subjectId The subject identifier
     * @return No content
     */
    followSubject(subjectId: string): Promise<void> {
        let url_ = this.baseUrl + "/subject/{subjectId}/follow";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFollowSubject(_response);
        });
    }

    protected processFollowSubject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param subjectId The subject identifier
     * @return No content
     */
    resolveSubject(subjectId: string): Promise<void> {
        let url_ = this.baseUrl + "/subject/{subjectId}/resolve";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResolveSubject(_response);
        });
    }

    protected processResolveSubject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param subjectId The subject identifier
     * @param body The new subject rating
     * @return No content
     */
    rateSubject(subjectId: string, body: SubjectRatings): Promise<void> {
        let url_ = this.baseUrl + "/subject/{subjectId}/rate";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRateSubject(_response);
        });
    }

    protected processRateSubject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param subjectId The subject identifier
     * @param body The standardization options
     * @return No content
     */
    standardizeSubject(subjectId: string, body: StandardizationRequest): Promise<void> {
        let url_ = this.baseUrl + "/subject/{subjectId}/standardize";
        if (subjectId === undefined || subjectId === null)
            throw new Error("The parameter 'subjectId' must be defined.");
        url_ = url_.replace("{subjectId}", encodeURIComponent("" + subjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStandardizeSubject(_response);
        });
    }

    protected processStandardizeSubject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The requested modules, ordered by name ascending
     */
    queryTrainingModules(body: QueryRequest): Promise<QueryResponse_TrainingModuleModel_> {
        let url_ = this.baseUrl + "/training/module/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryTrainingModules(_response);
        });
    }

    protected processQueryTrainingModules(response: Response): Promise<QueryResponse_TrainingModuleModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_TrainingModuleModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_TrainingModuleModel_>(null as any);
    }

    /**
     * @param body The training module identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the training module names as values. Id that are not found are ignored in the result.
     */
    getTrainingModuleNames(body: string[]): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/training/module/getTrainingModuleNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingModuleNames(_response);
        });
    }

    protected processGetTrainingModuleNames(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param name The name to search in the module database
     * @return The matching modules from the database
     */
    searchTrainingModule(name: string): Promise<IdAndNameModel[]> {
        let url_ = this.baseUrl + "/training/module/search?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchTrainingModule(_response);
        });
    }

    protected processSearchTrainingModule(response: Response): Promise<IdAndNameModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdAndNameModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdAndNameModel[]>(null as any);
    }

    /**
     * @param trainingModuleId The training module identifier
     * @return The training module model
     */
    getTrainingModuleById(trainingModuleId: string): Promise<TrainingModuleModel> {
        let url_ = this.baseUrl + "/training/module/{trainingModuleId}";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingModuleById(_response);
        });
    }

    protected processGetTrainingModuleById(response: Response): Promise<TrainingModuleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingModuleModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingModuleModel>(null as any);
    }

    /**
     * @param trainingModuleId The module identifier to update
     * @param body The training module update options
     * @return No content
     */
    updateTrainingModule(trainingModuleId: string, body: CreateOrUpdateTrainingModuleRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/module/{trainingModuleId}";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTrainingModule(_response);
        });
    }

    protected processUpdateTrainingModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingModuleId The module identifier to delete
     * @return No content
     */
    deleteTrainingModule(trainingModuleId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/module/{trainingModuleId}";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTrainingModule(_response);
        });
    }

    protected processDeleteTrainingModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The training module creation options
     * @return The created training module
     */
    createTrainingModule(body: CreateOrUpdateTrainingModuleRequest): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/training/module";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTrainingModule(_response);
        });
    }

    protected processCreateTrainingModule(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param trainingModuleId The module identifier to update
     * @param body The training module update options
     * @return No content
     */
    setTrainingModuleEnabled(trainingModuleId: string, body: SetTrainingModuleEnabledRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/module/{trainingModuleId}/setEnabled";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTrainingModuleEnabled(_response);
        });
    }

    protected processSetTrainingModuleEnabled(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingModuleId The module identifier to request
     * @return The statistics about the module usage in the training path
     */
    getTrainingModuleUsageStats(trainingModuleId: string): Promise<TrainingModuleUsageStats> {
        let url_ = this.baseUrl + "/training/module/{trainingModuleId}/usage";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingModuleUsageStats(_response);
        });
    }

    protected processGetTrainingModuleUsageStats(response: Response): Promise<TrainingModuleUsageStats> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingModuleUsageStats;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingModuleUsageStats>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return The training path model
     */
    getTrainingPathById(trainingPathId: string): Promise<TrainingPathModel> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingPathById(_response);
        });
    }

    protected processGetTrainingPathById(response: Response): Promise<TrainingPathModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingPathModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingPathModel>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    deleteTrainingPath(trainingPathId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTrainingPath(_response);
        });
    }

    protected processDeleteTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path to update.
     * @param body The training path
     * @return No content
     */
    updateTrainingPath(trainingPathId: string, body: UpdateTrainingPathRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTrainingPath(_response);
        });
    }

    protected processUpdateTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return The training path status
     */
    getTrainingPathStatusById(trainingPathId: string): Promise<TrainingPathStatus> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/status";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingPathStatusById(_response);
        });
    }

    protected processGetTrainingPathStatusById(response: Response): Promise<TrainingPathStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingPathStatus;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingPathStatus>(null as any);
    }

    /**
     * @param body The training path identifiers
     * @return The mapping that contains the training path info for each training path id found
     */
    getTrainingPathInfoByIds(body: string[]): Promise<{ [key: string]: TrainingPathInfoModel; }> {
        let url_ = this.baseUrl + "/training/path/infos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingPathInfoByIds(_response);
        });
    }

    protected processGetTrainingPathInfoByIds(response: Response): Promise<{ [key: string]: TrainingPathInfoModel; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: TrainingPathInfoModel; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: TrainingPathInfoModel; }>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The requested path, ordered by date descending (oldest will be the last)
     */
    queryTrainingPaths(body: QueryRequest): Promise<QueryResponse_TrainingPathModel_> {
        let url_ = this.baseUrl + "/training/path/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryTrainingPaths(_response);
        });
    }

    protected processQueryTrainingPaths(response: Response): Promise<QueryResponse_TrainingPathModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_TrainingPathModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_TrainingPathModel_>(null as any);
    }

    /**
     * @param body The training path creation options
     * @return The created training path
     */
    createTrainingPaths(body: CreateTrainingPathRequest): Promise<EntityCreatedModel[]> {
        let url_ = this.baseUrl + "/training/path";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateTrainingPaths(_response);
        });
    }

    protected processCreateTrainingPaths(response: Response): Promise<EntityCreatedModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel[]>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    cancelTrainingPath(trainingPathId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/cancel";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCancelTrainingPath(_response);
        });
    }

    protected processCancelTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    startTrainingPath(trainingPathId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/start";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartTrainingPath(_response);
        });
    }

    protected processStartTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    implicitStartTrainingPath(trainingPathId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/implicit_start";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImplicitStartTrainingPath(_response);
        });
    }

    protected processImplicitStartTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path to start. It must belong to the user.
     * @param body The content of the signature body (=the associatedcomment)
     * @return No content
     */
    validateTrainingPath(trainingPathId: string, body: TrainingPathValidationRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/validate";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processValidateTrainingPath(_response);
        });
    }

    protected processValidateTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path to start. It must belong to the user.
     * @param body The content of the signature body (=the associatedcomment)
     * @return No content
     */
    signTrainingPath(trainingPathId: string, body: SignatureRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/sign";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignTrainingPath(_response);
        });
    }

    protected processSignTrainingPath(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @return No content
     */
    updateTrainingPathResults(trainingPathId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/update";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateTrainingPathResults(_response);
        });
    }

    protected processUpdateTrainingPathResults(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @param body The grade given to the module
     * @return No content
     */
    setAssignedModuleGrade(trainingPathId: string, moduleIndex: number, body: SetGradeRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/grade";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetAssignedModuleGrade(_response);
        });
    }

    protected processSetAssignedModuleGrade(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @return No content
     */
    startTrainingPathModuleNow(trainingPathId: string, moduleIndex: number): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/startNow";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStartTrainingPathModuleNow(_response);
        });
    }

    protected processStartTrainingPathModuleNow(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @return No content
     */
    disableTrainingPathModule(trainingPathId: string, moduleIndex: number): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/disable";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisableTrainingPathModule(_response);
        });
    }

    protected processDisableTrainingPathModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path to start. It must belong to the user.
     * @param moduleIndex The index of the module in the training path
     * @param body The content of the signature body (=the associatedcomment)
     * @return No content
     */
    signAssignedModule(trainingPathId: string, moduleIndex: number, body: SignatureRequest): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/sign";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSignAssignedModule(_response);
        });
    }

    protected processSignAssignedModule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier
     * @param moduleIndex The index of the module in the training path
     * @param resultIndex The index of the module item for which to put a result
     * @return No content
     */
    setTrainingPathUrlResult(trainingPathId: string, moduleIndex: number, resultIndex: number): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/{resultIndex}/url";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        if (resultIndex === undefined || resultIndex === null)
            throw new Error("The parameter 'resultIndex' must be defined.");
        url_ = url_.replace("{resultIndex}", encodeURIComponent("" + resultIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetTrainingPathUrlResult(_response);
        });
    }

    protected processSetTrainingPathUrlResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier to modify
     * @param moduleIndex The index of the module in the training path
     * @param resultIndex The index of the module item for which to attach a mediation
     * @param mediationId The id of the mediation to attach
     * @return No content
     */
    attachMediationToTrainingPathResult(trainingPathId: string, moduleIndex: number, resultIndex: number, mediationId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/{resultIndex}/mediation/attach/{mediationId}";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        if (resultIndex === undefined || resultIndex === null)
            throw new Error("The parameter 'resultIndex' must be defined.");
        url_ = url_.replace("{resultIndex}", encodeURIComponent("" + resultIndex));
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAttachMediationToTrainingPathResult(_response);
        });
    }

    protected processAttachMediationToTrainingPathResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingPathId The training path identifier to modify
     * @param moduleIndex The index of the module in the training path
     * @param resultIndex The index of the module item for which to attach a mediation
     * @param mediationId The id of the mediation to detach
     * @return No content
     */
    detachMediationFromTrainingPathResult(trainingPathId: string, moduleIndex: number, resultIndex: number, mediationId: string): Promise<void> {
        let url_ = this.baseUrl + "/training/path/{trainingPathId}/{moduleIndex}/{resultIndex}/mediation/detach/{mediationId}";
        if (trainingPathId === undefined || trainingPathId === null)
            throw new Error("The parameter 'trainingPathId' must be defined.");
        url_ = url_.replace("{trainingPathId}", encodeURIComponent("" + trainingPathId));
        if (moduleIndex === undefined || moduleIndex === null)
            throw new Error("The parameter 'moduleIndex' must be defined.");
        url_ = url_.replace("{moduleIndex}", encodeURIComponent("" + moduleIndex));
        if (resultIndex === undefined || resultIndex === null)
            throw new Error("The parameter 'resultIndex' must be defined.");
        url_ = url_.replace("{resultIndex}", encodeURIComponent("" + resultIndex));
        if (mediationId === undefined || mediationId === null)
            throw new Error("The parameter 'mediationId' must be defined.");
        url_ = url_.replace("{mediationId}", encodeURIComponent("" + mediationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDetachMediationFromTrainingPathResult(_response);
        });
    }

    protected processDetachMediationFromTrainingPathResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The query parameters
     * @return The requested assigned modules
     */
    queryAssignedTrainingModules(body: QueryRequest): Promise<QueryResponse_AssignedTrainingModuleQueryResultModel_> {
        let url_ = this.baseUrl + "/training/path/modules/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryAssignedTrainingModules(_response);
        });
    }

    protected processQueryAssignedTrainingModules(response: Response): Promise<QueryResponse_AssignedTrainingModuleQueryResultModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_AssignedTrainingModuleQueryResultModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_AssignedTrainingModuleQueryResultModel_>(null as any);
    }

    /**
     * @param trainingReferenceType The list of training references to query
     * @param body The query parameters
     * @return The requested modules, ordered by name ascending
     */
    queryTrainingReferences(trainingReferenceType: TrainingReferenceType, body: QueryRequest): Promise<QueryResponse_TrainingReferenceModel_> {
        let url_ = this.baseUrl + "/training/references/query/{trainingReferenceType}";
        if (trainingReferenceType === undefined || trainingReferenceType === null)
            throw new Error("The parameter 'trainingReferenceType' must be defined.");
        url_ = url_.replace("{trainingReferenceType}", encodeURIComponent("" + trainingReferenceType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryTrainingReferences(_response);
        });
    }

    protected processQueryTrainingReferences(response: Response): Promise<QueryResponse_TrainingReferenceModel_> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryResponse_TrainingReferenceModel_;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryResponse_TrainingReferenceModel_>(null as any);
    }

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param trainingReferenceCode The training reference identifier
     * @return The training reference model
     */
    getTrainingReference(trainingReferenceType: TrainingReferenceType, trainingReferenceCode: string): Promise<TrainingReferenceModel> {
        let url_ = this.baseUrl + "/training/references/{trainingReferenceType}/{trainingReferenceCode}";
        if (trainingReferenceType === undefined || trainingReferenceType === null)
            throw new Error("The parameter 'trainingReferenceType' must be defined.");
        url_ = url_.replace("{trainingReferenceType}", encodeURIComponent("" + trainingReferenceType));
        if (trainingReferenceCode === undefined || trainingReferenceCode === null)
            throw new Error("The parameter 'trainingReferenceCode' must be defined.");
        url_ = url_.replace("{trainingReferenceCode}", encodeURIComponent("" + trainingReferenceCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingReference(_response);
        });
    }

    protected processGetTrainingReference(response: Response): Promise<TrainingReferenceModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingReferenceModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingReferenceModel>(null as any);
    }

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param trainingReferenceCode The training reference info
     * @return No content
     */
    deleteTrainingReference(trainingReferenceType: TrainingReferenceType, trainingReferenceCode: string): Promise<void> {
        let url_ = this.baseUrl + "/training/references/{trainingReferenceType}/{trainingReferenceCode}";
        if (trainingReferenceType === undefined || trainingReferenceType === null)
            throw new Error("The parameter 'trainingReferenceType' must be defined.");
        url_ = url_.replace("{trainingReferenceType}", encodeURIComponent("" + trainingReferenceType));
        if (trainingReferenceCode === undefined || trainingReferenceCode === null)
            throw new Error("The parameter 'trainingReferenceCode' must be defined.");
        url_ = url_.replace("{trainingReferenceCode}", encodeURIComponent("" + trainingReferenceCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTrainingReference(_response);
        });
    }

    protected processDeleteTrainingReference(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param body The training reference info
     * @return No content
     */
    createOrUpdateTrainingReference(trainingReferenceType: TrainingReferenceType, body: TrainingReferenceModel): Promise<void> {
        let url_ = this.baseUrl + "/training/references/{trainingReferenceType}";
        if (trainingReferenceType === undefined || trainingReferenceType === null)
            throw new Error("The parameter 'trainingReferenceType' must be defined.");
        url_ = url_.replace("{trainingReferenceType}", encodeURIComponent("" + trainingReferenceType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateOrUpdateTrainingReference(_response);
        });
    }

    protected processCreateOrUpdateTrainingReference(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param trainingReferenceType The list in which the reference is stored
     * @param trainingReferenceCode The training reference identifier
     * @return The statistics about the reference usage in the training path and training modules
     */
    getTrainingReferenceUsageStats(trainingReferenceType: TrainingReferenceType, trainingReferenceCode: string): Promise<TrainingReferenceUsageStats> {
        let url_ = this.baseUrl + "/training/references/{trainingReferenceType}/{trainingReferenceCode}/usage";
        if (trainingReferenceType === undefined || trainingReferenceType === null)
            throw new Error("The parameter 'trainingReferenceType' must be defined.");
        url_ = url_.replace("{trainingReferenceType}", encodeURIComponent("" + trainingReferenceType));
        if (trainingReferenceCode === undefined || trainingReferenceCode === null)
            throw new Error("The parameter 'trainingReferenceCode' must be defined.");
        url_ = url_.replace("{trainingReferenceCode}", encodeURIComponent("" + trainingReferenceCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingReferenceUsageStats(_response);
        });
    }

    protected processGetTrainingReferenceUsageStats(response: Response): Promise<TrainingReferenceUsageStats> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingReferenceUsageStats;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingReferenceUsageStats>(null as any);
    }

    /**
     * @param name The name to search in the user database
     * @return The matching users from the database
     */
    searchUser(name: string): Promise<IdAndNameModel[]> {
        let url_ = this.baseUrl + "/user/search?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchUser(_response);
        });
    }

    protected processSearchUser(response: Response): Promise<IdAndNameModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdAndNameModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdAndNameModel[]>(null as any);
    }

    /**
     * @param body The user identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the user names as values. Id that are not found are ignored in the result.
     */
    getUserNames(body: string[]): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/user/getUserNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserNames(_response);
        });
    }

    protected processGetUserNames(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param body The identifiers of the groups to get users from
     * @return The matching users from the database
     */
    getUserByGroups(body: string[]): Promise<IdAndNameModel[]> {
        let url_ = this.baseUrl + "/user/byGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserByGroups(_response);
        });
    }

    protected processGetUserByGroups(response: Response): Promise<IdAndNameModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdAndNameModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdAndNameModel[]>(null as any);
    }

    /**
     * @param userId The user identifier
     * @return The user info
     */
    getUserById(userId: string): Promise<UserInfoModel> {
        let url_ = this.baseUrl + "/user/byId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserById(_response);
        });
    }

    protected processGetUserById(response: Response): Promise<UserInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoModel>(null as any);
    }

    /**
     * @param userId The id of the user to edit
     * @param body The user to edit
     * @return No content
     */
    editUser(userId: string, body: Id__): Promise<void> {
        let url_ = this.baseUrl + "/user/byId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditUser(_response);
        });
    }

    protected processEditUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param userId The id of the user to delete
     * @return No content
     */
    deleteUser(userId: string): Promise<void> {
        let url_ = this.baseUrl + "/user/byId/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body The users identifiers
     * @return The mapping that associates the found user identifiers with the resolved infos
     */
    getUsersByIds(body: string[]): Promise<{ [key: string]: UserInfoModel; }> {
        let url_ = this.baseUrl + "/user/byIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersByIds(_response);
        });
    }

    protected processGetUsersByIds(response: Response): Promise<{ [key: string]: UserInfoModel; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: UserInfoModel; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: UserInfoModel; }>(null as any);
    }

    /**
     * @param externalId The external user identifier
     * @return The info about the users that have the given externalId
     */
    findUsersByExternalId(externalId: string): Promise<UserInfoModel[]> {
        let url_ = this.baseUrl + "/user/byExternalId/{externalId}";
        if (externalId === undefined || externalId === null)
            throw new Error("The parameter 'externalId' must be defined.");
        url_ = url_.replace("{externalId}", encodeURIComponent("" + externalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindUsersByExternalId(_response);
        });
    }

    protected processFindUsersByExternalId(response: Response): Promise<UserInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoModel[]>(null as any);
    }

    /**
     * @param name The name to search in the user database
     * @return The matching users from the database
     */
    findUserByName(name: string): Promise<UserInfoModel[]> {
        let url_ = this.baseUrl + "/user/byName?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindUserByName(_response);
        });
    }

    protected processFindUserByName(response: Response): Promise<UserInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoModel[]>(null as any);
    }

    /**
     * @param login The login to search in the user database
     * @return The matching users from the database
     */
    findUserByLogin(login: string): Promise<UserInfoModel[]> {
        let url_ = this.baseUrl + "/user/byLogin?";
        if (login === undefined || login === null)
            throw new Error("The parameter 'login' must be defined and cannot be null.");
        else
            url_ += "login=" + encodeURIComponent("" + login) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindUserByLogin(_response);
        });
    }

    protected processFindUserByLogin(response: Response): Promise<UserInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInfoModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoModel[]>(null as any);
    }

    /**
     * @param body The user to create
     * @return The info about the created entity
     */
    createUser(body: CreateUserModel): Promise<EntityCreatedModel> {
        let url_ = this.baseUrl + "/user/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<EntityCreatedModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityCreatedModel;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityCreatedModel>(null as any);
    }

    /**
     * @param userId The id of the user to edit
     * @param body The info about the new password
     * @return No content
     */
    changeUserPassword(userId: string, body: ChangePasswordModel): Promise<void> {
        let url_ = this.baseUrl + "/user/changePassword/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processChangeUserPassword(_response);
        });
    }

    protected processChangeUserPassword(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param name The name to search in the user database
     * @return The matching groups from the database
     */
    searchGroup(name: string): Promise<IdAndNameModel[]> {
        let url_ = this.baseUrl + "/user/searchGroup?";
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchGroup(_response);
        });
    }

    protected processSearchGroup(response: Response): Promise<IdAndNameModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IdAndNameModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdAndNameModel[]>(null as any);
    }

    /**
     * @param body The user identifiers for which to resolve names
     * @return The map that gives the identifiers as key, and the user names as values. Id that are not found are ignored in the result.
     */
    getGroupNames(body: string[]): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/user/getGroupNames";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupNames(_response);
        });
    }

    protected processGetGroupNames(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * @param body The identifiers of the users for which to get the groups
     * @return The mapping of the users associated with the groups they belong to
     */
    getUsersGroups(body: string[]): Promise<{ [key: string]: IdAndNameModel[]; }> {
        let url_ = this.baseUrl + "/user/getUserGroups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersGroups(_response);
        });
    }

    protected processGetUsersGroups(response: Response): Promise<{ [key: string]: IdAndNameModel[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: IdAndNameModel[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: IdAndNameModel[]; }>(null as any);
    }
}

/** The result of a login operation */
export interface LoginResult {
    /** The authentication token */
    token: string;
    /** The URL where the user will be redirected after the login operation */
    redirectUrl: string;
}

/** The parameter to give to a login operation. */
export interface LoginModel {
    username: string;
    password: string;
    returnUrl?: string;
}

/** The result of a token renewal operation */
export interface RenewTokenResult {
    /** The new authentication token */
    token: string;
}

/** The result of a logout operation */
export interface LogoutResult {
    /** The URL where the user will be redirected after the logout operation */
    redirectUrl?: string;
}

export interface GroupModel {
    id: string;
    name: string;
}

/** Construct a type with a set of properties K of type T */
export interface String_ {
}

export interface VisitsModel {

    [key: string]: moment.Moment | any;
}

/** A named filter */
export interface SavedFilter {
    /** The name of the filter, given by the user */
    name: string;
    /** A value indicating whether this is the default filter
Undefined is considered equivalent to false. */
    isDefault?: boolean;
    /** The filter string */
    filter: string;
    /** The sorting order */
    sorting?: string;
}

/** The filters for this user */
export interface UserFilters {

    [key: string]: SavedFilter[] | any;
}

/** The request that allows to save a filter list */
export interface SaveFilterRequest {
    /** The type of entity list for which to save filters */
    entityType: string;
    /** The filters to save for this entity type.
This will overwrite the list for this entity type */
    filters: SavedFilter[];
}

/** The status of a training path */
export enum TrainingPathStatus {
    NotAccepted = "notAccepted",
    Accepted = "accepted",
    Started = "started",
    Finished = "finished",
    Validated = "validated",
    Archived = "archived",
    Canceled = "canceled",
}

/** The status of a training module */
export enum AssignedTrainingModuleStatus {
    NotStarted = "notStarted",
    Started = "started",
    Finished = "finished",
    Validated = "validated",
    Archived = "archived",
    Disabled = "disabled",
}

/** The types of training modules */
export enum TrainingModuleType {
    Training = "training",
    Qualification = "qualification",
    Other = "other",
}

/** defines selections for generation of PDF reports or Excel exports */
export interface TrainingPathReportSelectors {
    /** start date for selection period */
    start: string;
    /** stop date for selection period */
    stop: string;
    /** statutes of training paths to be taken into account */
    pathStatutes: TrainingPathStatus[];
    /** statutes of assigned modules to be taken into account */
    moduleStatutes: AssignedTrainingModuleStatus[];
    /** the type of module to be taken into account */
    moduleTypes: TrainingModuleType[];
    /** list of learner identifiers to be taken into account */
    learnerIdList: string[];
    /** list of group identifiers to be taken into account */
    groupIdList: string[];
}

/** Prinitng options for the entire PDF report or Excel export */
export interface DocumentReportOptions {
    /** printable title for reports (can't be empty) */
    documentTitle: string;
    /** if true, displays external ids (user number) for learners, referents and mediators */
    displayExternalIds: boolean;
    /** if true, displays signature zone for learners for each page (PDF only) */
    learnerSignature: boolean;
    /** if true, displays signature zone for manager for each page (PDF only) */
    managerSignature: boolean;
    /** manager signature label (can't be empty if manager signature is required) */
    managerSignatureLabel: string;
}

/** printing options for training paths in PDF reports and Excel exports */
export interface TrainingPathReportOptions {
    /** if true, displays module duration */
    duration: boolean;
    /** if true, displays module status */
    status: boolean;
    /** if true, displays training path completion (Percentage of module items seen out of the total number of module items in the path) */
    completion: boolean;
    /** if true, displays training path pass threshold */
    passThreshold: boolean;
    /** if true, displays obtained grade for the path (defined by training path manager or creator) */
    grade: boolean;
    /** if true, displays manager comment (set when grading) */
    managerComment: boolean;
    /** if true, displays learner comment (set when signing) */
    learnerComment: boolean;
    /** if true, displays learner satisfaction (set when signing) */
    learnerSatisfaction: boolean;
}

/** Prinitng options for modules in PDF report or Excel export */
export interface ModuleReportOptions {
    /** if false, none of module info is displayed, if true, depends of specific option for each element */
    module: boolean;
    /** if true, displays module type */
    moduleType: boolean;
    /** if true, displays module duration */
    duration: boolean;
    /** if true, displays module status */
    status: boolean;
    /** if true, displays module completion (%) */
    completion: boolean;
    /** if true, displays referent info (lastname, firstname, and user number, if asked with DocumentReportOptions) */
    referent: boolean;
    /** if true, displays mediations info */
    mediations: boolean;
    /** available only if mediations option is true
if true, displays mediators info */
    mediators: boolean;
    /** if true, displays module pass threshold */
    passThreshold: boolean;
    /** if true, displays obtained grade for the module (defined by referent) */
    grade: boolean;
    /** if true, displays referent comment (set when grading) */
    referentComment: boolean;
    /** if true, displays learner comment (set when signing) */
    learnerComment: boolean;
    /** if true, displays learner satisfaction (set when signing) */
    learnerSatisfaction: boolean;
}

/** A named training path report configuration parameters */
export interface SavedTrainingPathReportConfiguration {
    /** The friendly name of the configuration, given by the user */
    name: string;
    /** A value indicating whether this is the default filter */
    isDefault: boolean;
    /** selection parameters */
    selectors: TrainingPathReportSelectors;
    /** document options */
    documentOptions: DocumentReportOptions;
    /** training path options */
    pathOptions: TrainingPathReportOptions;
    /** assigned module options */
    moduleOptions: ModuleReportOptions;
}

/** Represents a login link with a specific identity provider */
export interface IdentityProviderModel {
    /** The URL where to redirect the user for login */
    loginUrl: string;
    /** The displayed name of the identity provider */
    name: string;
    /** The identity provider icon */
    iconUrl: string;
}

/** The type of item that the context is */
export enum ContextItemType {
    Site = "site",
    Cartography = "cartography",
    Activity = "activity",
    Function = "function",
    Subject = "subject",
    MindmapNode = "mindmapNode",
    Mediation = "mediation",
}

/** Represents a (sub-)activity in a cartography */
export interface ActivityModel {
    /** The unique identifier of the function */
    id: string;
    /** The function code */
    code: string;
    /** The function name */
    name: string;
    /** The item type in the context
always ContextItemType.acitvity */
    type: ContextItemType;
    /** The children activities */
    activities: ActivityModel[];
    /** The children subjects */
    subjects: SubjectModel[];
}

/** Represents the ancestor of an entity */
export interface ContextHierarchyNode {
    /** The ancestor's identifier */
    id: string;
    /** The ancestor's code, used to create links to V1 */
    code: string;
    /** The ancestor's name */
    name: string;
    /** The item type in the context */
    type: ContextItemType;
}

/** The model that represents where an entity is attached */
export interface ContextModel {
    /** The hierarchy where this item is placed.
This list starts with the root down to the closest ancestor. */
    hierarchy: ContextHierarchyNode[];
}

/** An event on an entity, made by a user (like XXX created this subject on ...) */
export interface LifetimeEvent {
    /** The user identifier that triggered the event */
    userId: string;
    /** The name of the user that triggered the event */
    userName: string;
    /** The event date */
    date: moment.Moment;
}

/** The events that can occur on a subject */
export interface SubjectLifetimeEventModel {
    /** The subject creation event.
The database does not always contain this info for older records. */
    creation?: LifetimeEvent;
    /** The date at which the subject was last updated.
May not be known for older subjects in the database. */
    lastUpdate?: LifetimeEvent;
    /** Who and when was this subject followed by a user (only the last if made multiple times).
It may not be defined if the subject is not followed by someone. */
    followed?: LifetimeEvent;
    /** Who resolved the subject and when. */
    resolved?: LifetimeEvent;
    /** When the criticity is rated */
    criticity?: LifetimeEvent;
    /** When the subject is recognized as a Standard */
    standardized?: LifetimeEvent;
}

/** The criticity of a subject */
export interface SubjectRatings {
    /** Is this subject frequent or not ? */
    frequency: number;
    /** Is this important for the company (money loss) ? */
    gravity: number;
    /** How easy is it detectable ? */
    detectability: number;
}

/** Represents a node in the causality chain of the mind map. */
export interface MindMapNode {
    /** The item's identifer */
    id: string;
    /** The item's code, unique in the context of a mind map */
    code: string;
    /** The mind map node's label */
    name: string;
    /** The item type in the context
always ContextItemType.mindmapNode */
    type: ContextItemType;
    /** The node status (formerly known as "pertinence") */
    status?: string;
}

/** Represents a subject in a cartography */
export interface SubjectModel {
    /** The subject unique identifier. */
    id: string;
    /** The subject code, used to create the V1 identifiers when concatenated with the cartography code */
    code: string;
    /** The subject title */
    name: string;
    /** The item type in the context
always ContextItemType.subject */
    type: ContextItemType;
    /** The Organization hierarchy where this subject is placed */
    contexts: ContextModel[];
    /** The events that occurred on this subject */
    lifetimeEvents: SubjectLifetimeEventModel;
    /** The last time the mindmap was updated.

This is kept for historical reasons, because subjects that were last edited before 1.5 don't have lifetimeEvents.lastUpdate set.
This may be undefined if no mindmap is associated with the object */
    lastMindmapUpdate?: moment.Moment;
    /** The criticity ratings of the subject */
    ratings?: SubjectRatings;
    /** The identifier of the attached discussion */
    discussionId: string;
    /** The items of the causality chain that are linked directly or indirectly to this subject. */
    mindMapItems: MindMapNode[];
    /** Indicates whether the subject has a diagram (formerly known as "savoir-faire" or "notice basse") */
    hasDiagram: boolean;
    /** The identifiers of the users that have modified this subject */
    contributors: string[];
}

/** Represents a function in a cartography */
export interface FunctionModel {
    /** The unique identifier of the function */
    id: string;
    /** The function code */
    code: string;
    /** The function name */
    name: string;
    /** The identifier of the attached discussion */
    discussionId: string;
    /** The item type in the context
always ContextItemType.function */
    type: ContextItemType;
}

/** Stats about read/writes operations on the cartography */
export interface CartographyStatsModel {
    /** Aggregated number of reads of items in this cartography */
    reads: number;
    /** Aggregated number of writes of items in this cartography */
    writes: number;
}

/** Represents a cartography, used to describe the functions of an Organization */
export interface CartographyModel {
    /** The cartography unique identifier */
    id: string;
    /** The cartography code, used in the V1 urls */
    code: string;
    /** The cartography name */
    name: string;
    /** The item type in the context
always ContextItemType.cartography */
    type: ContextItemType;
    /** The activities of this cartography
For now, there are always 4 activities by design. */
    activities: ActivityModel[];
    /** The functions of this cartography */
    functions: FunctionModel[];
    /** The identifier of the attached discussion */
    discussionId: string;
    /** Stats about read/writes operations on the cartography */
    stats: CartographyStatsModel;
}

/** Represents a group of cartographies in the same geographic location */
export interface SiteModel {
    /** The site unique identifier */
    id: string;
    /** The site code, used in the V1 urls */
    code: string;
    /** The site name */
    name: string;
    /** The item type in the context
always ContextItemType.site */
    type: ContextItemType;
    /** The cartographies of this site */
    cartographies: CartographyModel[];
}

/** Generic structure that associates an id with a displayed name. It can be used to display users, groups... on an interface without having all the details of the entity */
export interface IdAndNameModel {
    /** The identifier */
    id: string;
    /** The displayed name */
    name: string;
}

/** The result that is returned by a name resolution method The key is the id and the value is the name. */
export interface NameResolutionResult {

    [key: string]: string | any;
}

/** A clickable zone on the cartography image */
export interface CartographyZone {
    /** The type of link that this is (either 'activity' or 'function') */
    type: ContextItemType;
    /** The linked item identifier */
    id: string;
    /** The zone coordinates, in pixels, relative to the cartography image */
    zone: Zone;
}

/** The type of system message */
export enum SystemMessageType {
    Created = "created",
    Updated = "updated",
    MindMapUpdated = "mindMapUpdated",
    DuplicatedFrom = "duplicatedFrom",
    Followed = "followed",
    Resolved = "resolved",
    Criticity = "criticity",
    Standardized = "standardized",
    StatusChanged = "statusChanged",
    TrackingPeriodsChanged = "trackingPeriodsChanged",
    MediationSigned = "mediationSigned",
    ResourceCreated = "resourceCreated",
    ResourceUpdated = "resourceUpdated",
    ResourceDeleted = "resourceDeleted",
}

/** The metadata that gives machine-processable info about a system message */
export interface SystemMessageMetadata {
    /** The message type */
    type: SystemMessageType;
    /** The message arguments */
    arguments: string[];
}

/** A message in a discussion */
export interface MessageModel {
    /** The message identifier */
    id: string;
    /** The author identifier */
    authorId: string;
    /** The author name */
    author: string;
    /** The UTC date time, expressed in ISO 8601 */
    date: moment.Moment;
    /** The metadata that gives info about system message.
Only set if the message is a system message. */
    systemMessageMetadata?: SystemMessageMetadata;
    /** The message content */
    content: string;
}

/** Represents a discussion as returned to the discussion page */
export interface DiscussionModel {
    /** The discussion id */
    id: string;
    /** The contexts where this discussion can be found.
While a discussion is always associated to only one parent,
one of its ancestor might be attached to several parents. */
    contexts: ContextModel[];
    /** All the messages in the discussion. */
    messages: MessageModel[];
}

/** The model that is returned by the post message method */
export interface CreatedMessageModel {
    /** The created message identifier */
    id: string;
    /** The message timestamp attributed by the server */
    timestamp: moment.Moment;
}

/** The request body that is transmitted with a postMessage operation */
export interface PostMessageRequest {
    /** The message content */
    content: string;
}

export enum TrackingMode {
    R = "R",
    W = "W",
}

/** The type of entity which was read or modified */
export enum TrackedEntityType {
    Cartography = "cartography",
    Function = "function",
    Subject = "subject",
    MindmapNode = "mindmapNode",
    Diagram = "diagram",
    Standard = "standard",
    Mediation = "mediation",
    LmsGroup = "lmsGroup",
    LmsResource = "lmsResource",
    LmsQuiz = "lmsQuiz",
    LmsForum = "lmsForum",
    LmsForumTopic = "lmsForumTopic",
    Qualification = "qualification",
}

/** The result of a tracking list query */
export interface TrackingActionResult {
    /** The action identifier, in the database */
    id: string;
    /** The action date */
    date: moment.Moment;
    /** The tracking mode (read or write) */
    mode: TrackingMode;
    /** The kind of entity that was affected */
    entityType: TrackedEntityType;
    /** The key of the affected entity */
    entityKey: string;
    /** The name of the entity that was affected */
    entityName: string;
}

/** The Read and Write counters result */
export interface ContributionCounter {
    /** The number of spot items viewed */
    views: number;
    /** The number of contributions on spot items */
    contributions: number;
}

/** The request object that selects specific users, items and dates from the database for a monthly contribution query */
export interface ContributionsQuery {
    /** The identifiers of the users to query */
    userIds: string[];
    /** The spot identifiers to query.
If empty, selects tracking for all items in the database */
    itemIds: string[];
    /** The year component of the start month */
    fromYear: number;
    /** The granularity of the request */
    granularity: ContributionsQueryGranularity;
    /** The month component of the start month (from 1 for january to 12) (if granularity == 'month') or
the week component of the start week (from 1 to 53) (if granularity == 'week') */
    start: number;
    /** The number of month/weeks to return */
    count: number;
}

/** The type of course model node */
export enum LmsCourseModelNodeType {
    Group = "group",
    Resource = "resource",
    Quiz = "quiz",
}

/** A quiz attempt */
export interface LmsQuizAttempt {
    /** The id of the quiz attempt */
    id: string;
    /** The obtained grade (/10) */
    grade: number;
    /** The date at which this attempt was finished */
    date: moment.Moment;
    /** The URL at which the attempt can be viewed */
    link: string;
}

/** The status of the mediation */
export enum MediationStatus {
    Created = "created",
    Started = "started",
    Paused = "paused",
    Stopped = "stopped",
    Validated = "validated",
    Archived = "archived",
    Canceled = "canceled",
}

/** An activity period of a mediation (between a start and a pause/stop) */
export interface TrackingPeriodModel {
    /** The start date of the period */
    start: moment.Moment;
    /** The stop date of the period, or undefined if this is the last period and if it is currently running. */
    stop?: moment.Moment;
}

/** The type of item in a report item */
export enum ReportItemType {
    Tracking = "tracking",
}

/** The report item that represents a report line from the database */
export interface ReportItemRelatedEntity {
    /** The type of the related entity */
    entityType: TrackedEntityType;
    /** The identifier of the related entity */
    id: string;
}

/** The report item that represents a report line from the database */
export interface MediationReportItem {
    /** The type of report item */
    itemType: ReportItemType;
    /** The id of the tracking item, if the report item is of type 'tracking' */
    trackingId?: string;
    /** The entity potentially associated with this report item */
    relatedEntity?: ReportItemRelatedEntity;
    /** The date at which the action was performed */
    date?: moment.Moment;
    /** The displayed message on the user interface */
    content: string;
}

/** A mediation report that includes what happened and associates tracking objects */
export interface MediationReport {
    /** The mediation report comment */
    comment: string;
    /** The mediation report items */
    items: MediationReportItem[];
}

/** Represents a mediation action */
export interface MediationModel {
    /** The mediation unique identifier */
    id: string;
    /** The mediation title, explaining what this is about */
    title: string;
    /** The mediation description */
    description: string;
    /** The status of the mediation */
    status: MediationStatus;
    /** The identifier of the attached discussion */
    discussionId: string;
    /** The scheduled starting date of the mediation. */
    schedulingDate?: moment.Moment;
    /** The date at which the mediation was last updated. */
    lastUpdate: LifetimeEvent;
    /** Tracking periods (between a start and a pause/stop) */
    trackingPeriods: TrackingPeriodModel[];
    /** The person who created the mediation */
    creator: IdAndNameModel;
    /** The person who gives the mediation */
    mediator: IdAndNameModel;
    /** The students that participates to this mediation */
    participants: IdAndNameModel[];
    /** The group of persons that are allowed to view this mediation */
    visibleByGroups: IdAndNameModel[];
    /** The individual persons that are allowed to view this mediation */
    visibleByPersons: IdAndNameModel[];
    /** The mediation reporting (what happened) */
    reporting?: MediationReport;
    /** The signatures of this mediation */
    signatures: LifetimeEvent[];
}

/** The result object of a query */
export interface QueryResponse_MediationModel_ {
    /** The query results in the page */
    results: MediationModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** The interface that allows to perform a query/filtering against a list of objects */
export interface QueryRequest {
    /** The query string to be passed to the queryEngine */
    query: string;
    /** The page number (0-based) */
    page?: number;
    /** The maximum number of items per page. If not set, gets all the items, regardless of the given `page` parameter */
    pageSize?: number;
    /** The criteria used to sort the results.
This is the list of the fields to sort on, separated by `,`.
The fields that are sorted in descending order are prefixed with `-` */
    sorting?: string;
}

/** The model that is returned by a create* method */
export interface EntityCreatedModel {
    /** The created entity identifier */
    id: string;
}

/** The model that is passed when the connected user wants to : create a new mediation or update the general info about a mediation */
export interface CreateOrUpdateMediationRequest {
    /** The mediation title, explaining what this is about */
    title: string;
    /** The mediation description */
    description: string;
    /** The scheduled starting date of the mediation.
If this is a creation, undefined here means that the mediation starts now.
If this is an update operation, this must be filled if the mediation has not started yet */
    schedulingDate?: moment.Moment;
    /** The id of the person who gives the mediation. Undefined means that the creator is the mediator */
    mediator: string;
    /** The ids of the students that participates to this mediation */
    participants: string[];
    /** The id of the groups of persons that are allowed to view this mediation */
    visibleByGroups: string[];
    /** The id of the individual persons that are allowed to view this mediation */
    visibleByPersons: string[];
}

/** The new status that is requested */
export enum RequestedMediationStatus {
    Started = "started",
    Paused = "paused",
    Stopped = "stopped",
    Validated = "validated",
    Canceled = "canceled",
}

/** The request to change a mediation status */
export interface MediationStatusRequest {
    /** The requested mediation status */
    status: RequestedMediationStatus;
}

export interface OrganisationInformation {
    customerName: string;
}

/** The permissions set on a group */
export interface GroupPermission {
    id: string;
    name: string;
    permissions: string[];
}

/** the interface to define an item level for SPOT elements (site, cartography, ...) */
export interface TreeItem {
    /** the item information */
    item: IdAndNameModel;
    /** the children for this item (lower level, can be empty) */
    children: TreeItem[];
}

/** Represents the activity pictos as data-url, keyed by the activity id */
export interface CartographyActivityPictos {

    [key: string]: string | any;
}

/** Represents a qualification object returned from the API */
export interface QualificationModel {
    /** The qualification identifier */
    id: string;
    /** The name of the qualification */
    name: string;
    /** The list of cartographies (that represent the workstations for which there is a need for a qualification) */
    cartographies: string[];
    /** The identifiers of the groups of users that should be qualified */
    qualifiableGroups: string[];
    /** The modules that must be succeeded in order to be qualified. */
    modules: string[];
    /** The identifier of the attached discussion */
    discussionId: string;
}

/** The result object of a query */
export interface QueryResponse_QualificationModel_ {
    /** The query results in the page */
    results: QualificationModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** Represents the status of a module in a user qualification */
export interface UserQualificationModuleModel {
    /** The module identifier */
    module: string;
    /** The expiration date (as a date-only) at which the validation of this module expires. This date may be in the past
This is basically last successDate + module.periodicity
This field is set to an empty string if the module has no periodicity, and to undefined if the module has never been validated. */
    validUntil?: string;
    /** The last training path that validated the module.
This is undefined if the module has never been validated */
    validationTrainingPath?: string;
    /** A value indicating the training path in which this module is currently planned for a requalification.
This is undefined if the module is not planned for requalification */
    requalificationTrainingPath?: string;
}

/** Represents the status of a qualification for a user */
export interface UserQualificationModel {
    /** The user identifier */
    user: string;
    /** The qualification identifier */
    qualification: string;
    /** The qualification name */
    qualificationName: string;
    /** The modules required for this qualification for a user */
    modules: UserQualificationModuleModel[];
}

/** The result object of a query */
export interface QueryResponse_UserQualificationModel_ {
    /** The query results in the page */
    results: UserQualificationModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** The model that represents a request to create or update a qualification */
export interface CreateOrUpdateQualificationRequest {
    /** The name of the qualification */
    name: string;
    /** The list of cartographies (that represent the workstations for which there is a need for a qualification) */
    cartographies: string[];
    /** The groups of users that should be qualified */
    qualifiableGroups: string[];
    /** The modules that must be succeeded in order to be qualified. */
    modules: string[];
}

/** the types of resources */
export enum ResourceType {
    Image = "image",
    Pdf = "pdf",
    File = "file",
    Link = "link",
    Youtube = "youtube",
}

/** The model that represents a resource attached to an entity */
export interface ResourceModel {
    /** The resource identifier */
    id: string;
    /** The displayed name of the resource */
    name: string;
    /** The type of resource */
    resourceType: ResourceType;
    /** If this resource type is attached to a file (file, image, pdf...),
this is defined and mime type is set to the mime type of the attached file */
    mimeType?: string;
    /** If this resource type is attached to a file (file, image, pdf...),
this contains the original name of the resource file.
Otherwise, this contains the URI of the resource. */
    link: string;
    /** The (optional) comment given on this resource. */
    comment?: string;
}

/** The type of object that contains the given resource */
export enum ResourceParentType {
    Function = "function",
    Subject = "subject",
    Qualification = "qualification",
}

/** the model that represents updateable fields of a resource */
export interface UpdateResourceModel {
    /** The displayed name of the resource */
    name: string;
    /** If this resource type is attached to a file (file, image, pdf...),
this contains the original name of the resource file, and can't be updated.
Otherwise, this contains the URI of the resource. */
    link: string;
    /** The (optional) comment given on this resource. */
    comment?: string;
}

/** The request object in the "createSubject" and "editSubject" methods */
export interface CreateOrUpdateSubjectRequest {
    /** The subject name. */
    name: string;
    /** The identifier of the cartography in which this subject is */
    cartographyId: string;
    /** The identifier of the function in which this subject is.
This function must be under cartographyId */
    functionId: string;
    /** The activity identifier in which this subject is
This activity must be under cartographyId */
    activityId: string;
}

/** The model that is sent when a subject is standardized */
export interface StandardizationRequest {
    /** The comment associated with the standardization */
    comment: string;
}

/** Represents a reference code in an external training management system. A reference code may be set on a training path or a training module, and queries can be made on training path or training modules to find all the training that matches the code. The training path references are stored in a different list than the training module references. */
export interface TrainingReferenceModel {
    /** The reference code, which is used as an identifier */
    code: string;
    /** The user-friendly name for this reference */
    label: string;
    /** The user-friendly description for this reference */
    description: string;
    /** A boolean value indicating whether the reference is disabled (cannot be used in new training path and training modules) */
    disabled: boolean;
}

export enum TrainingModuleItemType {
    Lms = "lms",
    Spot = "spot",
    Url = "url",
    Mediation = "mediation",
}

export enum SpotModuleItemType {
    Cartography = "cartography",
    Activity = "activity",
    Function = "function",
    Subject = "subject",
}

/** The API model that represents a training module */
export interface TrainingModuleModel {
    /** The module identifier */
    id: string;
    /** The displayed name of the module */
    name: string;
    /** the type of training module (the use that is made of it) */
    moduleType: TrainingModuleType;
    /** The objectives of this module */
    goals: string;
    /** A value indicating whether this module can be added to a user's training path */
    enabled: boolean;
    /** The estimated duration of the module, as an integer number of minutes */
    estimatedDuration: number;
    /** The reference in external systems */
    reference?: TrainingReferenceModel;
    /** The info about who and when created this training module */
    creation: LifetimeEvent;
    /** When a learner is validated for this module, the validation remains for this number of month.
After that, the module must be passed again.

0 means that this module doesn't have a periodicity */
    periodicity: number;
    /** The minimum grade (/10) that a user must obtain for them to validate the module. */
    passThreshold: number;
    /** The items that a user must complete in order to validate this module */
    moduleItems: TrainingModuleItemModel[];
}

/** The result object of a query */
export interface QueryResponse_TrainingModuleModel_ {
    /** The query results in the page */
    results: TrainingModuleModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** The request to create or update a training module */
export interface CreateOrUpdateTrainingModuleRequest {
    /** The displayed name of the module */
    name: string;
    /** the type of training module (the use that is made of it) */
    moduleType: TrainingModuleType;
    /** The objectives of this module */
    goals: string;
    /** The estimated duration of the module, as an integer number of minutes */
    estimatedDuration: number;
    /** The reference code in external systems */
    reference?: string;
    /** When a learner is validated for this module, the validation remains for this number of month.
After that, the module must be passed again.

0 means that this module doesn't have a periodicity */
    periodicity: number;
    /** The minimum grade (/10) that a user must obtain for them to validate the module. */
    passThreshold: number;
    /** The items that a user must complete in order to validate this module */
    moduleItems: TrainingModuleItemModel[];
}

/** The request that sets the enabled property of a training module */
export interface SetTrainingModuleEnabledRequest {
    /** A boolean indicating the new status of the training module.
Disabled modules cannot be affected to new training path anymore */
    enabled: boolean;
}

/** Statistics about the usage of this module */
export interface TrainingModuleUsageStats {
    /** The number of training path that include this module */
    trainingPath: number;
    /** A boolean indicating whether one of the training path using this module has already been accepted */
    hasAcceptedTrainingPath: boolean;
}

/** The info about a user visit on a subject during the module */
export interface SpotSubjectResult {
    /** The id of the subject */
    subjectId: string;
    /** The date at which the learner last visited this subject */
    doneAt: moment.Moment;
}

/** The model that contains the module grade */
export interface TrainingModuleGradeModel {
    /** The referent that has defined this grade */
    referent: IdAndNameModel;
    /** The grade, between 0 and 10 */
    grade: number;
    /** A boolean indicating whether the grade was above the minimal grade */
    isSuccess: boolean;
    /** The date at which the referent gave that grade */
    date: moment.Moment;
    /** The date (as a date-only) at which the validation expires.
This is only set if the module was succeeded, and if the periodicity was > 0
This is basically date + module.periodicity */
    validUntil?: string;
    /** The comment given by the referent */
    comment: string;
}

/** The signature of a training module or a training path */
export interface TrainingSignatureModel {
    /** The date at which the learner signed this module */
    date: moment.Moment;
    /** The comment set by the learner when signing */
    comment: string;
    /** The user satisfaction, expressed as a number between 1 and 5, 0 means unknown (coming from an old version where satisfaction didn't exist) */
    satisfaction: number;
}

/** The module assigned to a user */
export interface AssignedTrainingModuleModel {
    /** The module description */
    module: TrainingModuleModel;
    /** The index of the assigned module in the training path.
Useful when assigning a grade to the assigned module, to attach a mediation... */
    index: number;
    /** The module status */
    status: AssignedTrainingModuleStatus;
    /** The users that are allowed to validate that the user has succeeded/failed the module. */
    referents: IdAndNameModel[];
    /** Indicates whether this assigned module is disabled (doesn't count for the final grade). */
    disabled: boolean;
    /** The start datetime of the module */
    startDate: moment.Moment;
    /** The stop datetime of the module
The learner should complete all items in the module by this date */
    stopDate: moment.Moment;
    /** The result for each item in the module.
This array is filled with as many items as there are moduleItems in the module */
    results: TrainingModuleItemResult[];
    /** The learner grade, or undefined if the referent did not give a grade yet */
    grading?: TrainingModuleGradeModel;
    /** The learner signature */
    signature?: TrainingSignatureModel;
}

/** The validation of a training path */
export interface TrainingPathValidationModel {
    /** The date at which the learner signed this module */
    date: moment.Moment;
    /** The user that validated the training path */
    validator: IdAndNameModel;
    /** The comment set by the learner when signing */
    comment: string;
}

/** Represents the modules assigned to a user on a specific date range. A user may be enrolled in several training path on the same time period. */
export interface TrainingPathModel {
    /** The training path identifier in the database */
    id: string;
    /** The learner, i.e. the person to which is assigned the training Path */
    learner: IdAndNameModel;
    /** The group of persons that are allowed to view this training path */
    visibleByGroups: IdAndNameModel[];
    /** The individual persons that are allowed to view this training path */
    visibleByPersons: IdAndNameModel[];
    /** The training path status */
    status: TrainingPathStatus;
    /** The info about who and when created this training module */
    creation: LifetimeEvent;
    /** The training path title */
    title: string;
    /** The reference code in external systems */
    reference?: TrainingReferenceModel;
    /** The start datetime of the training path */
    startDate: moment.Moment;
    /** The stop datetime of the training path
The learner should complete all its module by this date. */
    stopDate: moment.Moment;
    /** The minimum grade (/10) that a user must obtain for them to validate the training path. */
    passThreshold: number;
    /** The date of the acceptance of the training path by the learner */
    acceptanceDate?: moment.Moment;
    /** The modules assigned to this user, and the user results, that are visible to the requesting user. */
    assignedModules: AssignedTrainingModuleModel[];
    /** The number of sub-module items that were done on this training path */
    doneSubModuleItems: number;
    /** The total number of sub-module items in this training path */
    totalSubModuleItems: number;
    /** The sum of all estimated duration of all enabled modules, in minutes */
    totalEstimatedDuration: number;
    /** The number of enabled assigned modules in this training path */
    totalAssignedModules: number;
    /** The training path manager's signature */
    validation?: TrainingPathValidationModel;
    /** The learner signature */
    signature?: TrainingSignatureModel;
}

/** Is equivalent to the TrainingPathModel, without the assignedModules */
export interface TrainingPathInfoModel {
    /** The training path identifier in the database */
    id: string;
    /** The learner, i.e. the person to which is assigned the training Path */
    learner: IdAndNameModel;
    /** The group of persons that are allowed to view this training path */
    visibleByGroups: IdAndNameModel[];
    /** The individual persons that are allowed to view this training path */
    visibleByPersons: IdAndNameModel[];
    /** The training path status */
    status: TrainingPathStatus;
    /** The info about who and when created this training module */
    creation: LifetimeEvent;
    /** The training path title */
    title: string;
    /** The reference code in external systems */
    reference?: TrainingReferenceModel;
    /** The start datetime of the training path */
    startDate: moment.Moment;
    /** The stop datetime of the training path
The learner should complete all its module by this date. */
    stopDate: moment.Moment;
    /** The minimum grade (/10) that a user must obtain for them to validate the training path. */
    passThreshold: number;
    /** The date of the acceptance of the training path by the learner */
    acceptanceDate?: moment.Moment;
    /** The number of sub-module items that were done on this training path */
    doneSubModuleItems: number;
    /** The total number of sub-module items in this training path */
    totalSubModuleItems: number;
    /** The sum of all estimated duration of all enabled modules, in minutes */
    totalEstimatedDuration: number;
    /** The number of enabled assigned modules in this training path */
    totalAssignedModules: number;
    /** The training path manager's signature */
    validation?: TrainingPathValidationModel;
    /** The learner signature */
    signature?: TrainingSignatureModel;
}

/** The result that contains several training path info (without assigned modules) */
export interface TrainingPathInfoResult {

    [key: string]: TrainingPathInfoModel | any;
}

/** The result object of a query */
export interface QueryResponse_TrainingPathModel_ {
    /** The query results in the page */
    results: TrainingPathModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** The options for creating a module assignment to a user */
export interface AssignedTrainingModuleCreationOptions {
    /** The module identifier */
    moduleId: string;
    /** The identifier of the users that are allowed to validate that the user has succeeded/failed the module. */
    referents: string[];
    /** The start datetime of the module */
    startDate: moment.Moment;
    /** The stop datetime of the module
The learner should complete all items in the module by this date */
    stopDate: moment.Moment;
}

/** The request that allows the creation of a training path for many learners */
export interface CreateTrainingPathRequest {
    /** The identifiers of the users for which to assign the training path */
    learnerIds: string[];
    /** The group of persons that are allowed to view this training path */
    visibleByGroups: string[];
    /** The individual persons that are allowed to view this training path */
    visibleByPersons: string[];
    /** The training path title */
    title: string;
    /** The reference code in external systems */
    reference?: string;
    /** The start datetime of the training path */
    startDate: moment.Moment;
    /** The stop datetime of the training path
The learner should complete all its modules by this date. */
    stopDate: moment.Moment;
    /** The minimum grade (/10) that a user must obtain for them to validate the training path. */
    passThreshold: number;
    /** The configuration parameters of the modules to assign. */
    assignedModules: AssignedTrainingModuleCreationOptions[];
}

/** The request that allows to edit the training path */
export interface UpdateTrainingPathRequest {
    /** The group of persons that are allowed to view this training path */
    visibleByGroups: string[];
    /** The individual persons that are allowed to view this training path */
    visibleByPersons: string[];
    /** The training path title */
    title: string;
    /** The reference code in external systems */
    reference?: string;
    /** The start datetime of the training path */
    startDate: moment.Moment;
    /** The stop datetime of the training path
The learner should complete all its modules by this date. */
    stopDate: moment.Moment;
    /** The minimum grade (/10) that a user must obtain for them to validate the training path. */
    passThreshold: number;
    /** The configuration parameters of the modules to assign. */
    assignedModules: AssignedTrainingModuleCreationOptions[];
}

/** The model that is sent when a user validates a training path */
export interface TrainingPathValidationRequest {
    /** The comment that the user left */
    comment: string;
}

/** The model that is sent when a user signs a training path or a training module */
export interface SignatureRequest {
    /** The comment that the user left */
    comment: string;
    /** The user satisfaction, expressed as a number between 1 and 5 */
    satisfaction: number;
}

/** The model that is sent to assign a grade on an assigned module */
export interface SetGradeRequest {
    /** The grade, between 0 and 10 */
    grade: number;
    /** The comment given by the referent */
    comment: string;
}

/** A result of an AssignedTrainingModule query */
export interface AssignedTrainingModuleQueryResultModel {
    /** The result of the request */
    assignedModule: AssignedTrainingModuleModel;
    /** The learner */
    learner: IdAndNameModel;
    /** The id of the training path this module belongs to */
    trainingPathId: string;
    /** A boolean indicating whether the training path is canceled */
    trainingPathIsCanceled: boolean;
}

/** The result object of a query */
export interface QueryResponse_AssignedTrainingModuleQueryResultModel_ {
    /** The query results in the page */
    results: AssignedTrainingModuleQueryResultModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** The result object of a query */
export interface QueryResponse_TrainingReferenceModel_ {
    /** The query results in the page */
    results: TrainingReferenceModel[];
    /** The total number of items (useful to get the number of pages) */
    totalItems: number;
}

/** The list in which the reference is stored */
export enum TrainingReferenceType {
    Path = "path",
    Module = "module",
}

export interface TrainingReferenceUsageStats {
    /** The number of usage that are currently made of this training reference.
If the usage count is 0, the reference may be deleted */
    count: number;
}

/** Info about a user */
export interface UserInfoModel {
    /** The user identifier */
    id: string;
    /** The user's login */
    login: string;
    /** The user e-mail address */
    email: string;
    /** The user last name */
    lastName: string;
    /** The user first name */
    firstName: string;
    /** The user groups identifiers */
    groups: string[];
    /** A boolean indicating whether the account is active, i.e. it has not been deleted or suspended */
    isActive: boolean;
    /** The user identifier in an external database managed by the customer. */
    externalId?: string;
    /** The identifer of the user's manager in this database.
This field is reserved for future use and is not persisted anywhere */
    managerId?: string;
    /** The date at which the user has entered into the company.
This field is reserved for future use and is not persisted anywhere */
    companyEntry?: moment.Moment;
    /** The date at which the user will exit or has exited the company.
This field is reserved for future use and is not persisted anywhere */
    companyExit?: moment.Moment;
    /** The user service in the company.
This field is reserved for future use and is not persisted anywhere */
    companyService?: string;
    /** the site where user works */
    city?: string;
}

/** The result of a user info resolution */
export interface UserResolutionResult {

    [key: string]: UserInfoModel | any;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface IdOrIsActive__ {
    /** The user's login */
    login: string;
    /** The user e-mail address */
    email: string;
    /** The user last name */
    lastName: string;
    /** The user first name */
    firstName: string;
    /** The user groups identifiers */
    groups: string[];
    /** The user identifier in an external database managed by the customer. */
    externalId?: string;
    /** The identifer of the user's manager in this database.
This field is reserved for future use and is not persisted anywhere */
    managerId?: string;
    /** The date at which the user has entered into the company.
This field is reserved for future use and is not persisted anywhere */
    companyEntry?: moment.Moment;
    /** The date at which the user will exit or has exited the company.
This field is reserved for future use and is not persisted anywhere */
    companyExit?: moment.Moment;
    /** The user service in the company.
This field is reserved for future use and is not persisted anywhere */
    companyService?: string;
    /** the site where user works */
    city?: string;
}

/** The model used to change the password of a user */
export interface ChangePasswordModel {
    /** The new user password */
    password: string;
    /** Whether the user must change their password at next login */
    mustChangePassword: boolean;
}

/** The model that describes the creation of a user */
export interface CreateUserModel extends IdOrIsActive__ {
    /** The new user password */
    password: string;
    /** Whether the user must change their password at next login */
    mustChangePassword: boolean;
}

/** From T, pick a set of properties whose keys are in the union K */
export interface Id__ {
    /** A boolean indicating whether the account is active, i.e. it has not been deleted or suspended */
    isActive: boolean;
    /** The user's login */
    login: string;
    /** The user e-mail address */
    email: string;
    /** The user last name */
    lastName: string;
    /** The user first name */
    firstName: string;
    /** The user groups identifiers */
    groups: string[];
    /** The user identifier in an external database managed by the customer. */
    externalId?: string;
    /** The identifer of the user's manager in this database.
This field is reserved for future use and is not persisted anywhere */
    managerId?: string;
    /** The date at which the user has entered into the company.
This field is reserved for future use and is not persisted anywhere */
    companyEntry?: moment.Moment;
    /** The date at which the user will exit or has exited the company.
This field is reserved for future use and is not persisted anywhere */
    companyExit?: moment.Moment;
    /** The user service in the company.
This field is reserved for future use and is not persisted anywhere */
    companyService?: string;
    /** the site where user works */
    city?: string;
}

/** The result that is returned by a group resolution method (for all those ids, get me all the associated entites id and name) The key is the id and the value is the list of "groups" id and names */
export interface GroupResolutionResult {

    [key: string]: IdAndNameModel[] | any;
}

export interface Zone {
    height: number;
    width: number;
    y: number;
    x: number;
}

export enum ContributionsQueryGranularity {
    Month = "month",
    Week = "week",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

// Imported class for NSwag code generation to use the x-access-token in the http fetch requests
// See also https://github.com/RSuter/NSwag/issues/734

// Use `npm run nswag` or NSwag Studio with the .nswag to generate the code.

/**
 * Info about a user. This is stored in the OAuth token.
 */
export interface UserModel {
  id: string,
  name:string,
  groups: GroupModel[],
  permissions: string[],
  additionalProperties?: Record<string, string>
}

/**
 * The common part of all Couch*ModuleItemResult
 */
export interface CommonModuleItemResult {
  /**
   * The date at which this item has been done (the definition of "done" may vary from type to type).
   * Undefined if it has not been done yet.
   */
  doneAt?: moment.Moment;

  /**
   * The number of sub-items that were completed
   */
  doneSubModuleItems: number;

  /**
   * The total number of sub-items
   */
  totalSubModuleItems: number;
}

/**
 * A module item of type LMS
 */
export interface LmsTrainingModuleItemModel {
  type: TrainingModuleItemType.Lms;

  /**
   * The course identifier in the Learning Management System.
   */
  lmsCourseId: string;
}

/**
 * The info about a user visit on a resource during the module
 */
export interface LmsCourseResourceResult {
  /**
   * The id of the course resource
   */
  resourceId: string;

  /**
   * The date at which the learner last visited this resource
   */
  doneAt: moment.Moment;
}

/**
 * A quiz item in a LMS course item
 */
export interface LmsQuizResult {
  /**
   * The id of the quiz in the LMS database
   */
  quizId: string;

  /**
   * The unique identifiers of the attempts in the LMS database
   */
  attemptsIds: string[];

  /**
   * The grade (/10) that the user got.
   */
  result: number;

  /**
   * The date at which the grade was obtained
   */
  doneAt: moment.Moment;
}

/**
 * A module item result of type lms
 */
export interface LmsTrainingModuleItemResult extends CommonModuleItemResult {
  type: TrainingModuleItemType.Lms;

  /**
   * The list of LMS courses results that were seen by the user during the module period
   */
  resources: LmsCourseResourceResult[];

  /**
   * The list of LMS quizes that were done during the module period and the associated results
   */
  quizes: LmsQuizResult[];
}

/**
 * A module item of type spot
 */
export interface SpotTrainingModuleItemModel {
  type: TrainingModuleItemType.Spot;

  /**
   * The type of item designated by the spotItemId property
   */
  spotItemType: SpotModuleItemType;

  /**
   * The identifier of an entity in the spot database
   */
  spotItemId: string;
}

/**
 * A module item result of type spot
 */
export interface SpotTrainingModuleItemResult extends CommonModuleItemResult {
  type: TrainingModuleItemType.Spot;

  /**
   * The list of the viewed subjects during the module period
   */
  subjects: SpotSubjectResult[];
}

/**
 * A module item of type url
 */
export interface UrlTrainingModuleItemModel {
  type: TrainingModuleItemType.Url;

  /**
   * The url of the item to learn from
   */
  url: string;

  /**
   * The displayed text on the hypertext link
   */
  label: string;
}

/**
 * A module item result of type url
 */
export interface UrlTrainingModuleItemResult extends CommonModuleItemResult {
  type: TrainingModuleItemType.Url;
}

/**
 * A module item of type mediation
 */
export interface MediationTrainingModuleItemModel {
  type: TrainingModuleItemType.Mediation;

  /**
   * The title of the mediations that will be created based on this mediation module item
   */
  title: string;

  /**
   * The description of the mediations that will be created based on this mediation module item
   */
  description: string;
}

/**
 * A module item result of type mediation
 */
export interface MediationTrainingModuleItemResult extends CommonModuleItemResult {
  type: TrainingModuleItemType.Mediation;

  /**
   * The list of the attached mediation
   */
  mediationIds: string[];
}

/**
 * An item that a user must complete in a TrainingModuleModel
 */
export type TrainingModuleItemModel = LmsTrainingModuleItemModel | SpotTrainingModuleItemModel | UrlTrainingModuleItemModel | MediationTrainingModuleItemModel;

/**
 * The result of a training module item
 */
export type TrainingModuleItemResult = LmsTrainingModuleItemResult | SpotTrainingModuleItemResult | UrlTrainingModuleItemResult | MediationTrainingModuleItemResult;

/**
 * Represents a group, a resource or a quiz in the course tree
 */
export type LmsCourseModelNode = LmsCourseModelGroupNode | LmsCourseModelLeafNode;

export interface LmsCourseModelGroupNode {
  /**
   * The type of node
   */
  type: LmsCourseModelNodeType.Group;

  /**
   * The unique id of the node.
   */
  id: string;

  /**
   * The node name
   */
  name: string;

  /**
   * The children of the node
   */
  children: LmsCourseModelNode[];

  /**
   * The url on which to redirect the user.
   * Always set if the node is of type resource or quiz
   */
  url?: string;
}

export interface LmsCourseModelLeafNode {
  /**
   * The type of node
   */
  type: LmsCourseModelNodeType.Resource | LmsCourseModelNodeType.Quiz;

  /**
   * The unique id of the node.
   */
  id: string;

  /**
   * The node name
   */
  name: string;

  /**
   * The url on which to redirect the user.
   */
  url: string;
}
